/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum UserSearchSortBy {
  Created = "Created",
  Modified = "Modified",
  Name = "Name",
  Email = "Email",
}

export enum UserRole {
  None = "None",
  Lawyer = "Lawyer",
  Administrator = "Administrator",
}

export enum SigningRule {
  None = "None",
  OnlyCeo = "OnlyCeo",
  CeoAndHeadOfBoard = "CeoAndHeadOfBoard",
  TwoBoardMembers = "TwoBoardMembers",
  TheCombinedDirection = "TheCombinedDirection",
  EntireDirection = "EntireDirection",
}

export enum SigningProvider {
  ESignatur = "ESignatur",
  AddoSign = "AddoSign",
}

export enum ShopWebsiteArea {
  Frontpage = "Frontpage",
  Auth = "Auth",
  Forms = "Forms",
  Dashboard = "Dashboard",
}

export enum NotificationType {
  Success = "Success",
  Info = "Info",
  Warning = "Warning",
  Error = "Error",
}

export enum NotificationTarget {
  Dashboard = "Dashboard",
}

export enum NotificationPosition {
  Top = "Top",
  Bottom = "Bottom",
  Center = "Center",
}

export enum NotificationAlignment {
  Left = "Left",
  Right = "Right",
  Center = "Center",
}

export enum ManagementType {
  None = "None",
  Direction = "Direction",
  DirectionAndBoard = "DirectionAndBoard",
}

export enum KycSubmissionStatus {
  Draft = "Draft",
  AwaitingSignature = "AwaitingSignature",
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected",
  Cancelled = "Cancelled",
}

export enum KycScreeningState {
  Running = "Running",
  Completed = "Completed",
  Failed = "Failed",
  NotConfigured = "NotConfigured",
}

export enum KycScreeningSource {
  DanishPep = "DanishPep",
  OpenSanctions = "OpenSanctions",
  Cvr = "Cvr",
}

export enum KycRuleAction {
  Block = "Block",
  ManualReview = "ManualReview",
}

export enum KycRiskClassification {
  Low = "Low",
  Elevated = "Elevated",
  High = "High",
}

export enum KycMatchDecision {
  DifferentPerson = "DifferentPerson",
  Relevant = "Relevant",
}

export enum KycFieldType {
  Heading = "Heading",
  Paragraph = "Paragraph",
  ShortText = "ShortText",
  LongText = "LongText",
  SingleChoice = "SingleChoice",
  MultipleChoice = "MultipleChoice",
  Checkbox = "Checkbox",
  Date = "Date",
  Number = "Number",
  Email = "Email",
  Upload = "Upload",
}

export enum KycConditionOperator {
  Equals = "Equals",
  NotEquals = "NotEquals",
  Contains = "Contains",
  NotEmpty = "NotEmpty",
  AgeBelow = "AgeBelow",
}

export enum FounderType {
  None = "None",
  Person = "Person",
  Company = "Company",
}

export enum FormRequestType {
  None = "None",
  SoleProprietorship = "SoleProprietorship",
  OperatingCompany = "OperatingCompany",
  Ltd = "Ltd",
}

export enum FormConsentStatus {
  NotAnswered = "NotAnswered",
  Accepted = "Accepted",
  Declined = "Declined",
}

export enum ForeignOwnerType {
  None = "None",
  WithinEurope = "WithinEurope",
  OutsideEurope = "OutsideEurope",
}

export enum FiscalYear {
  None = "None",
  FirstJanTo31Dec = "FirstJanTo31Dec",
  FirstJulyTo30June = "FirstJulyTo30June",
}

export enum EmployeePaymentType {
  None = "None",
  Salary = "Salary",
  Commission = "Commission",
}

export enum EmailFlowTarget {
  Owner = "Owner",
  Admin = "Admin",
}

export enum EmailFlowEvent {
  UserSignup = "UserSignup",
  CaseCreated = "CaseCreated",
  AddressDocumentUploaded = "AddressDocumentUploaded",
  AddressDocumentDeclined = "AddressDocumentDeclined",
  KycCompleted = "KycCompleted",
  CaseDocumentSigned = "CaseDocumentSigned",
  CapitalTransferred = "CapitalTransferred",
  CapitalTransferDeclined = "CapitalTransferDeclined",
  CapitalTransferAccepted = "CapitalTransferAccepted",
  CapitalReturned = "CapitalReturned",
  CompanyCreated = "CompanyCreated",
  BankDocumentUploaded = "BankDocumentUploaded",
  BankAccountDeclined = "BankAccountDeclined",
  BankAccountConfirmed = "BankAccountConfirmed",
  SelskabsMappeCreated = "SelskabsMappeCreated",
  CasePaymentCompleted = "CasePaymentCompleted",
}

export enum DocumentTemplateType {
  None = "None",
  EnkeltmandsVirksomhed = "EnkeltmandsVirksomhed",
  Aps = "Aps",
  ApsHolding = "ApsHolding",
  As = "As",
  AsHolding = "AsHolding",
  Selskabsmappe = "Selskabsmappe",
  Ejerbog = "Ejerbog",
}

export enum DictionaryLabelContentType {
  Text = "Text",
  HTML = "HTML",
}

export enum CompanyVatType {
  Vat = "Vat",
  Payroll = "Payroll",
}

export enum CompanyType {
  None = "None",
  ApS = "ApS",
  A_S = "A_S",
}

export enum CompanyStructure {
  None = "None",
  OperatingCompany = "OperatingCompany",
  HoldingCompany = "HoldingCompany",
  HoldingStructure = "HoldingStructure",
}

export enum CompanyPayrollType {
  None = "None",
  TouristInformationLottery = "TouristInformationLottery",
  InsuranceBanking = "InsuranceBanking",
  NewsPaper = "NewsPaper",
  DoctorDentistEducationMuseumTaxi = "DoctorDentistEducationMuseumTaxi",
}

export enum CaseStep {
  Payment = "Payment",
  Identification = "Identification",
  DocumentSigning = "DocumentSigning",
  CapitalTransfer = "CapitalTransfer",
  CvrNumber = "CvrNumber",
  CompanyCreated = "CompanyCreated",
  BankAccount = "BankAccount",
  CapitalReturn = "CapitalReturn",
  Completed = "Completed",
}

export enum CaseStatus {
  Active = "Active",
  Locked = "Locked",
  Closed = "Closed",
}

export enum CaseSearchSortBy {
  Created = "Created",
  Modified = "Modified",
  Title = "Title",
  Progress = "Progress",
}

export enum CasePersonType {
  Founder = "Founder",
  Director = "Director",
  BoardMember = "BoardMember",
  BeneficialOwner = "BeneficialOwner",
}

export enum CaseEventLogType {
  Flow = "Flow",
  Email = "Email",
  CustomerIoIdentify = "CustomerIoIdentify",
  CustomerIoTrack = "CustomerIoTrack",
  Webhook = "Webhook",
}

export enum CaseEventLogStatus {
  Succeeded = "Succeeded",
  Failed = "Failed",
}

export enum AdminWebsiteArea {
  Dashboard = "Dashboard",
  Users = "Users",
  Dictionary = "Dictionary",
  Statistics = "Statistics",
  Administration = "Administration",
  Auth = "Auth",
}

export enum AddoPurpose {
  Kyc = "Kyc",
  CaseDocuments = "CaseDocuments",
}

export enum AddoAttemptStatus {
  Queued = "Queued",
  Creating = "Creating",
  AwaitingSignature = "AwaitingSignature",
  Completed = "Completed",
  Expired = "Expired",
  Cancelled = "Cancelled",
  Rejected = "Rejected",
  Failed = "Failed",
  NeedsReconciliation = "NeedsReconciliation",
  CreationRejected = "CreationRejected",
}

export interface CreateCompanyRequest {
  TypeDiscriminator: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  companyName: string;
  /** @maxItems 5 */
  secondaryNames: string[];
  /** @minLength 1 */
  street: string;
  /** @minLength 1 */
  city: string;
  /** @minLength 1 */
  postalCode: string;
  /** @maxLength 255 */
  brancheKode?: string | null;
  acceptTerms: boolean;
  consentAnswers?: FormConsentAnswerRequest[] | null;
}

export interface AddFormConsentRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 5000
   */
  text: string;
  /** @format int32 */
  sortOrder: number;
  showForApS: boolean;
  showForAS: boolean;
  showForSoleProprietorship: boolean;
}

export interface AddOrUpdateAllowableIpsRequest {
  /** @format uuid */
  userId: string;
  allowableIps: string[];
}

export interface AddOrUpdateDictionaryLanguageRequest {
  /** @minLength 1 */
  languageCode: string;
  /** @minLength 1 */
  dictionaryKey: string;
  isFallback: boolean;
}

export interface AddOrUpdateEmailFlowRequest {
  /** @format uuid */
  id?: string | null;
  event: EmailFlowEvent;
  target: EmailFlowTarget;
  /**
   * @minLength 1
   * @maxLength 255
   */
  subject: string;
  /**
   * @minLength 1
   * @maxLength 50000
   */
  body: string;
  enabled: boolean;
}

export interface AddOrUpdateNotificationRequest {
  /** @format uuid */
  id?: string | null;
  /**
   * @minLength 1
   * @maxLength 1000
   */
  title: string;
  /** @maxLength 2000 */
  message?: string | null;
  /** @format date-time */
  activeFrom?: string | null;
  /** @format date-time */
  activeTo?: string | null;
  target: NotificationTarget;
  type: NotificationType;
  alignment: NotificationAlignment;
  position: NotificationPosition;
  fullWidth: boolean;
  enabled: boolean;
}

export type AddOrUpdateUserRequest = CreateUserRequest & {
  /** @format uuid */
  id?: string | null;
};

export interface AddPartnerRequest {
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  iconUrl: string;
  /** @minLength 1 */
  websiteUrl: string;
  /** @minLength 1 */
  accentColor: string;
}

export interface AddPaymentFeeRequest {
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  price: number;
  includeVAT: boolean;
  appliesToSoleProprietorship: boolean;
  appliesToApS: boolean;
  appliesToAS: boolean;
}

export interface AddoAttemptView {
  /** @format uuid */
  id: string;
  /** @format uuid */
  caseId: string;
  /** @format int32 */
  signingId?: number | null;
  purpose: AddoPurpose;
  status: AddoAttemptStatus;
  lastError?: string | null;
  /** @format date-time */
  created: string;
}

export interface AddoAttemptViewListClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: AddoAttemptView[] | null;
}

export interface AddressViewObject {
  name?: string | null;
  street?: string | null;
  postalCode?: string | null;
  city?: string | null;
  country?: string | null;
  floor?: string | null;
  door?: string | null;
}

export interface Base64EncodedFile {
  fileName: string;
  data: string;
}

export interface Base64EncodedImage {
  /** @minLength 1 */
  fileName: string;
  /** @minLength 1 */
  data: string;
}

export interface BeneficialOwnerRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format double */
  ownershipPercentage: number;
  /**
   * @minLength 10
   * @maxLength 10
   */
  cprNumber?: string | null;
  /** @format tel */
  phoneNumber?: string | null;
  street?: string | null;
  city?: string | null;
  postalCode?: string | null;
}

export interface BooleanClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model: boolean;
}

export interface BrancheNode {
  text: string;
  section: string;
  group_code?: string | null;
  nodes?: BrancheNode[] | null;
}

export interface BrancheNodeArrayClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: BrancheNode[] | null;
}

export type CaseEventLogViewObject = GuidEntityViewObject & {
  type: CaseEventLogType;
  status: CaseEventLogStatus;
  source: string;
  context: string;
  action: string;
  recipient?: string | null;
  subject?: string | null;
  payload?: string | null;
  description?: string | null;
  errorMessage?: string | null;
};

export interface CaseEventLogsViewModel {
  events: CaseEventLogViewObject[];
}

export interface CaseEventLogsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseEventLogsViewModel | null;
}

export interface CaseFileViewModel {
  file: CaseFileViewObject;
}

export interface CaseFileViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseFileViewModel | null;
}

export type CaseFileViewObject = GuidEntityViewObject & {
  /** @format uuid */
  caseId: string;
  url: string;
  fileName: string;
  contentType: string;
  /** @format int64 */
  fileSize: number;
};

export interface CaseFilesViewModel {
  files: CaseFileViewObject[];
}

export interface CaseFilesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseFilesViewModel | null;
}

export interface CaseKycSubmissionView {
  signingStatus?: AddoAttemptStatus | null;
  requiresInternalReview: boolean;
  /** @format uuid */
  id: string;
  /** @format uuid */
  subjectId: string;
  isParticipant: boolean;
  status: KycSubmissionStatus;
  rejectionReason?: string | null;
}

export interface CaseKycSubmissionViewListClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseKycSubmissionView[] | null;
}

export interface CasePersonCompanyParticipantViewModel {
  participant: CasePersonCompanyParticipantViewObject;
}

export interface CasePersonCompanyParticipantViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasePersonCompanyParticipantViewModel | null;
}

export type CasePersonCompanyParticipantViewObject = KycEntityViewObject & {
  /** @format uuid */
  casePersonId: string;
  name: string;
  role: string;
  relationDescription?: string | null;
};

export interface CasePersonCompanyParticipantViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasePersonCompanyParticipantViewObject | null;
}

export interface CasePersonViewModel {
  person: CasePersonViewObject;
}

export interface CasePersonViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasePersonViewModel | null;
}

export type CasePersonViewObject = KycEntityViewObject & {
  /** @format uuid */
  caseId: string;
  name: string;
  email: string;
  cprNumber?: string | null;
  cvrNumber?: string | null;
  phoneNumber?: string | null;
  companyParticipants: CasePersonCompanyParticipantViewObject[];
  types: CasePersonType[];
  /** @format int32 */
  paidInCapital: number;
  /** @format int32 */
  paidInCapitalPercentage: number;
  address: AddressViewObject;
  signUrl?: string | null;
  signedAt?: string | null;
  verificationLinkSentDate?: string | null;
  /** @format uuid */
  verificationLinkSentBy?: string | null;
  participantsVerificationLinkSentDate?: string | null;
  /** @format uuid */
  participantsVerificationLinkSentBy?: string | null;
  hasSignedDocument: boolean;
};

export interface CasePersonViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasePersonViewObject | null;
}

export interface CasePersonsViewModel {
  persons: CasePersonViewObject[];
}

export interface CasePersonsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasePersonsViewModel | null;
}

export interface CasePlatformPayment {
  /** @format uuid */
  productId: string;
  productName: string;
  /** @format int32 */
  amount: number;
  fees: CasePlatformPaymentFee[];
  /** @format int32 */
  total: number;
}

export interface CasePlatformPaymentFee {
  /** @format uuid */
  id: string;
  name: string;
  /** @format int32 */
  price: number;
  includeVAT: boolean;
}

export interface CaseSearchFilter {
  searchTerm?: string | null;
  status?: CaseStatus | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  pageSize: number;
  sortBy: CaseSearchSortBy;
  desc: boolean;
  /** @format uuid */
  ownerId?: string | null;
}

export interface CaseViewModel {
  case: CaseViewObject;
}

export interface CaseViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseViewModel | null;
}

export type CaseViewObject = GuidEntityViewObject & {
  title: string;
  status: CaseStatus;
  /** @format int32 */
  capital: number;
  kommune: string;
  documentFilePath?: string | null;
  ejerbogFilePath?: string | null;
  selskabsFilePath?: string | null;
  selskabsMappeFilePath?: string | null;
  kycVerificationFilePath?: string | null;
  /** @format uuid */
  documentOrderId?: string | null;
  kycProvider: SigningProvider;
  documentSigningProvider: SigningProvider;
  /** @format uuid */
  addoDocumentAttemptId?: string | null;
  documentSigningRequestedDate?: string | null;
  /** @format uuid */
  documentSigningRequestedBy?: string | null;
  documentSigningRequired: boolean;
  documentSigned: boolean;
  companyCapitalRequired: boolean;
  companyCapitalTransferRequired: boolean;
  bankAccountRequired: boolean;
  signedDocumentUploaded: boolean;
  capitalTransferConfirmationDate?: string | null;
  formSubmission: FormSubmissionViewObject;
  /** @format uuid */
  groupChatId: string;
  persons: CasePersonViewObject[];
  kycVerified: boolean;
  kycRequired: boolean;
  platformPayment?: CasePlatformPayment | null;
  paymentCompleted: boolean;
  paymentCompletedDate?: string | null;
  /** @format uuid */
  paymentCompletedBy?: string | null;
  identificationCompletedDate?: string | null;
  /** @format uuid */
  identificationCompletedBy?: string | null;
  documentSigningCompletedDate?: string | null;
  /** @format uuid */
  documentSigningCompletedBy?: string | null;
  /** @format uuid */
  capitalTransferConfirmationBy?: string | null;
  capitalTransferMarkedDate?: string | null;
  /** @format uuid */
  capitalTransferMarkedBy?: string | null;
  capitalTransferRejectedDate?: string | null;
  /** @format uuid */
  capitalTransferRejectedBy?: string | null;
  paymentReceiptUrl?: string | null;
  hasPaymentInvoice: boolean;
  paymentProductName?: string | null;
  /** @format int32 */
  paymentAmount?: number | null;
  cvrNumber?: string | null;
  cvrNumberCompletedDate?: string | null;
  /** @format uuid */
  cvrNumberCompletedBy?: string | null;
  bankRegNumber?: string | null;
  bankAccountNumber?: string | null;
  iban?: string | null;
  bicSwift?: string | null;
  bankAccountDocumentFilePath?: string | null;
  bankAccountCompletedDate?: string | null;
  /** @format uuid */
  bankAccountCompletedBy?: string | null;
  bankAccountDocumentRejectedDate?: string | null;
  capitalReturnDate?: string | null;
  /** @format uuid */
  capitalReturnedBy?: string | null;
  /** @format int32 */
  step: number;
  companyType: string;
  /** @format int32 */
  unreadMessagesCount: number;
  owner: UserViewObject;
};

export interface CaseViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CaseViewObject | null;
}

export interface CasesSearchViewModel {
  cases: CaseViewObject[];
  /** @format int32 */
  totalCount: number;
  pendingKycReviewCaseIds: string[];
}

export interface CasesSearchViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasesSearchViewModel | null;
}

export interface CasesViewModel {
  cases: CaseViewObject[];
}

export interface CasesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CasesViewModel | null;
}

export interface ChangePasswordRequest {
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 1 */
  newPassword: string;
  /** @minLength 1 */
  newPasswordConfirm: string;
}

export interface CompanyTypeBreakdownViewObject {
  companyType: string;
  /** @format int32 */
  count: number;
}

export type ContactViewObject = GuidEntityViewObject & {
  name: string;
  lastName: string;
  fullName: string;
  email?: string | null;
  phoneNumber?: string | null;
};

export type CorrectKycAnswersRequest = KycAccessRequest & {
  /** @format uuid */
  submissionId: string;
  /** @format int32 */
  revision: number;
};

export interface CouponViewObject {
  id: string;
  name?: string | null;
  /** @format int64 */
  amountOff?: number | null;
  /** @format double */
  percentOff?: number | null;
  currency?: string | null;
  duration: string;
  /** @format int64 */
  maxRedemptions?: number | null;
  /** @format int64 */
  timesRedeemed: number;
  /** @format date-time */
  redeemBy?: string | null;
}

export interface CouponViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CouponViewObject | null;
}

export interface CouponsViewModel {
  coupons: CouponViewObject[];
}

export interface CouponsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CouponsViewModel | null;
}

export interface CreateChatRequest {
  members: string[];
  /** @maxLength 255 */
  title?: string | null;
}

export interface CreateCouponRequest {
  /** @minLength 1 */
  name: string;
  /** @format int64 */
  amountOff?: number | null;
  /** @format double */
  percentOff?: number | null;
  currency: string;
  /** @minLength 1 */
  duration: string;
  /** @format int64 */
  maxRedemptions?: number | null;
  /** @format date-time */
  redeemBy?: string | null;
}

export interface CreateHoldingStructureRequest {
  holdingCompany: CreateOperatingCompanyRequest;
  operatingCompany: CreateOperatingCompanyRequest;
}

export type CreateOperatingCompanyRequest = CreateCompanyRequest & {
  companyStructure: CompanyStructure;
  /**
   * @maxItems 10
   * @minItems 1
   */
  founders: Founder[];
  companyType: CompanyType;
  /** @minLength 1 */
  companyPurpose: string;
  employerRegistration?: boolean | null;
  dataLonOfferConsent?: boolean | null;
  vatRegistration?: boolean | null;
  managementType: ManagementType;
  hasCEO: boolean;
  directors: (PersonRequest | Founder)[];
  boardMembers: (PersonRequest | Founder)[];
  signingRule: SigningRule;
  fiscalYear: FiscalYear;
  /** @format date-time */
  startDate?: string | null;
  allHasDanishPassport: boolean;
  oneOrMoreEUResidence: boolean;
  oneOrMoreNoneEUResidence: boolean;
  bankruptcyQuarantine: boolean;
  foundersAreRealOwners: boolean;
  beneficialOwners: BeneficialOwnerRequest[];
  TypeDiscriminator: string;
};

export type CreateSoleProprietorshipRequest = CreateCompanyRequest & {
  founder: PersonRequest | Founder;
  ownerHasDanishPassport: boolean;
  foreignOwnerType: ForeignOwnerType;
  confirmNoOtherCompanyOwnership: boolean;
  companyVatType: CompanyVatType;
  companyPayrollType: CompanyPayrollType;
  employeesRequired: boolean;
  /** @format int32 */
  numberOfEmployees: number;
  /** @format date-time */
  startDateOfFirstEmployee?: string | null;
  employeePaymentType: EmployeePaymentType;
  confirmCase: boolean;
  TypeDiscriminator: string;
};

export interface CreateUserRequest {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @minLength 1 */
  email: string;
  /** @minLength 1 */
  phone: string;
  role: UserRole;
  profileImageUrl?: string | null;
}

export interface CvrCompany {
  name: string;
  coName: string;
  address: AddressViewObject;
  branche: string;
  cvrNumber: string;
  companyType: string;
  secondaryNames: string[];
}

export interface CvrCompanyArrayClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: CvrCompany[] | null;
}

export interface DataLonIntegrationViewModel {
  enabled: boolean;
  webhookConfigured: boolean;
}

export interface DataLonIntegrationViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DataLonIntegrationViewModel | null;
}

export interface DecideKycScreeningRequest {
  /** @format uuid */
  submissionId: string;
  /** @format uuid */
  runId: string;
  /** @maxLength 200 */
  matchId: string;
  decision: KycMatchDecision;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  reason: string;
}

export interface DeleteChatRequest {
  /** @format uuid */
  chatId: string;
}

export interface DeleteFormConsentRequest {
  /** @format uuid */
  formConsentId: string;
}

export interface DeletePartnerRequest {
  /** @format uuid */
  partnerId: string;
}

export interface DictionaryLabelByLanguageViewModel {
  label: DictionaryLabelByLanguagesViewObject;
}

export interface DictionaryLabelByLanguageViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DictionaryLabelByLanguageViewModel | null;
}

export interface DictionaryLabelByLanguagesViewObject {
  key: string;
  labels: DictionaryLabelViewObject[];
}

export interface DictionaryLabelViewObject {
  key: string;
  text: string;
  area?: string | null;
  languageCode: string;
  lastModified?: string | null;
  /** @format uuid */
  lastModifiedBy?: string | null;
  contentType: DictionaryLabelContentType;
}

export interface DictionaryLabelsByLanguageViewModel {
  labels: DictionaryLabelByLanguagesViewObject[];
}

export interface DictionaryLabelsByLanguageViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DictionaryLabelsByLanguageViewModel | null;
}

export interface DictionaryLabelsViewModel {
  labels: DictionaryLabelViewObject[];
}

export interface DictionaryLabelsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DictionaryLabelsViewModel | null;
}

export interface DictionaryLanguageViewModel {
  language: DictionaryLanguageViewObject;
}

export interface DictionaryLanguageViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DictionaryLanguageViewModel | null;
}

export interface DictionaryLanguageViewObject {
  languageCode: string;
  countryCode: string;
  dictionaryKey: string;
  isFallback: boolean;
}

export interface DictionaryLanguagesViewModel {
  languages: DictionaryLanguageViewObject[];
}

export interface DictionaryLanguagesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DictionaryLanguagesViewModel | null;
}

export interface DocumentTemplateFileViewObject {
  fileName: string;
  lastModified: string;
  lastModifiedBy?: string | null;
}

export interface DocumentTemplateFileViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DocumentTemplateFileViewObject | null;
}

export interface DocumentTemplatesViewModel {
  files: DocumentTemplateFileViewObject[];
}

export interface DocumentTemplatesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: DocumentTemplatesViewModel | null;
}

export interface EmailFlowViewModel {
  model: EmailFlowViewObject;
}

export interface EmailFlowViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: EmailFlowViewModel | null;
}

export type EmailFlowViewObject = GuidEntityViewObject & {
  event: EmailFlowEvent;
  target: EmailFlowTarget;
  enabled: boolean;
  subject: string;
  body: string;
};

export interface EmailFlowsViewModel {
  flows: EmailFlowViewObject[];
}

export interface EmailFlowsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: EmailFlowsViewModel | null;
}

export interface EmailSettingsViewModel {
  footerTemplate: string;
  casePersonKycLinkTemplate: string;
  casePersonParticipantsKycLinkTemplate: string;
  termsTemplate: string;
  emailTriggerFlowServiceEnabled: boolean;
}

export interface EmailSettingsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: EmailSettingsViewModel | null;
}

export interface FormConsentAnswerRequest {
  /** @format uuid */
  formConsentId: string;
  /** @minLength 1 */
  titleSnapshot: string;
  /** @minLength 1 */
  textSnapshot: string;
  isAccepted?: boolean | null;
}

export interface FormConsentViewModel {
  consent: FormConsentViewObject;
}

export interface FormConsentViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: FormConsentViewModel | null;
}

export type FormConsentViewObject = GuidEntityViewObject & {
  title: string;
  text: string;
  /** @format int32 */
  sortOrder: number;
  showForApS: boolean;
  showForAS: boolean;
  showForSoleProprietorship: boolean;
  isActive: boolean;
};

export interface FormConsentsViewModel {
  consents: FormConsentViewObject[];
}

export interface FormConsentsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: FormConsentsViewModel | null;
}

export type FormSubmissionConsentViewObject = GuidEntityViewObject & {
  /** @format uuid */
  formConsentId: string;
  title: string;
  text: string;
  status: FormConsentStatus;
};

export type FormSubmissionViewObject = GuidEntityViewObject & {
  requestType: FormRequestType;
  companyStructure: CompanyStructure;
  companyType: CompanyType;
  termsAccepted: boolean;
  request: CreateOperatingCompanyRequest | CreateSoleProprietorshipRequest;
  consents: FormSubmissionConsentViewObject[];
};

export interface FormsConfigurationViewModel {
  dataLonOfferEnabled: boolean;
}

export interface FormsConfigurationViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: FormsConfigurationViewModel | null;
}

export type Founder = PersonRequest & {
  type: FounderType;
  /**
   * @minLength 8
   * @maxLength 8
   */
  cvr?: string | null;
  isForeign?: boolean | null;
  /** @format int32 */
  paidInCapital: number;
};

export interface GeoLocation {
  /** @format double */
  accuracy: number;
  /** @format double */
  latitude: number;
  /** @format double */
  longitude: number;
  /** @format double */
  altitude?: number | null;
  /** @format double */
  altitudeAccuracy?: number | null;
  /** @format double */
  heading?: number | null;
  /** @format double */
  speed?: number | null;
}

export interface GroupChatMessageViewObject {
  /** @format uuid */
  id: string;
  /** @format uuid */
  chatId: string;
  /** @format uuid */
  senderUserId?: string | null;
  senderName: string;
  message: string;
  created: string;
  modified: string;
  readBy: string[];
}

export interface GroupChatMessageViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: GroupChatMessageViewObject | null;
}

export interface GroupChatMessagesViewModel {
  /** @format int32 */
  total: number;
  messages: GroupChatMessageViewObject[];
}

export interface GroupChatMessagesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: GroupChatMessagesViewModel | null;
}

export interface GroupChatViewModel {
  groupChats: GroupChatViewObject[];
}

export interface GroupChatViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: GroupChatViewModel | null;
}

export interface GroupChatViewObject {
  /** @format uuid */
  id: string;
  title?: string | null;
  created: string;
  updated?: string | null;
  /** @format uuid */
  createdBy?: string | null;
  /** @format int32 */
  unreadMessagesCount: number;
  ownerName?: string | null;
  ownerEmail?: string | null;
  messages: GroupChatMessageViewObject[];
}

export interface GroupChatViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: GroupChatViewObject | null;
}

export interface GuidEntityViewObject {
  /** @format uuid */
  id: string;
  /** @format uuid */
  createdBy?: string | null;
  created: string;
  modified?: string | null;
  /** @format uuid */
  modifiedBy?: string | null;
}

export type HttpValidationProblemDetails = ProblemDetails & {
  errors: Record<string, string[]>;
  [key: string]: any;
};

export interface HubConnectionViewObject {
  /** @format uuid */
  userId: string;
  connectionId: string;
  ipAddress?: string | null;
  connected: string;
  tokenVersion: string;
  activity: string;
  /** @format uuid */
  isTypingInChat?: string | null;
  lastActivity: string;
}

export interface ImagesUploadedResponse {
  imageUrls: string[];
}

export interface ImagesUploadedResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: ImagesUploadedResponse | null;
}

export interface InitiateCasePersonCompanyParticipantVerificationViewModel {
  participant: CasePersonCompanyParticipantViewObject;
  verificationUrl: string;
  clientSecret: string;
}

export interface InitiateCasePersonCompanyParticipantVerificationViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: InitiateCasePersonCompanyParticipantVerificationViewModel | null;
}

export interface InitiateCasePersonVerificationViewModel {
  person: CasePersonViewObject;
  verificationUrl: string;
  clientSecret: string;
}

export interface InitiateCasePersonVerificationViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: InitiateCasePersonVerificationViewModel | null;
}

export interface IpInformationViewObject {
  ip: string;
  zip: string;
  city: string;
  country: string;
  countryCode: string;
}

export interface IpInformationViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: IpInformationViewObject | null;
}

export interface KycAccessRequest {
  /**
   * @minLength 1
   * @maxLength 4000
   */
  token: string;
}

export interface KycAnswer {
  fieldId: string;
  value: string;
  values: string[];
}

export interface KycAttachmentView {
  /** @format uuid */
  id: string;
  fieldId: string;
  fileName: string;
  contentType: string;
  /** @format int32 */
  size: number;
}

export interface KycCondition {
  fieldId: string;
  operator: KycConditionOperator;
  value: string;
}

export interface KycDefinition {
  title: string;
  description: string;
  sections: KycSection[];
  rules: KycRule[];
}

export interface KycDownload {
  fileName: string;
  contentType: string;
  data: string;
}

export interface KycDownloadClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycDownload | null;
}

export type KycEntityViewObject = GuidEntityViewObject & {
  isPep?: boolean | null;
  sourceOfFunds?: string | null;
  stripeVerificationId?: string | null;
  verificationStatus?: string | null;
  verificationLastChecked?: string | null;
  verificationCompleted?: string | null;
  addressDocumentFilePath?: string | null;
  addressDocumentRejectedDate?: string | null;
  /** @format uuid */
  addressDocumentRejectedBy?: string | null;
  addressDocumentAcceptedDate?: string | null;
  /** @format uuid */
  addressDocumentAcceptedBy?: string | null;
  identityVerified: boolean;
  addressVerified: boolean;
  kycFormFilePath?: string | null;
  /** @format uuid */
  kycFormOrderId?: string | null;
  isVerified: boolean;
};

export interface KycField {
  id: string;
  type: KycFieldType;
  label: string;
  description: string;
  placeholder: string;
  defaultValue: string;
  required: boolean;
  /** @format int32 */
  width: number;
  /** @format int32 */
  minimumLength: number;
  futureDateOnly: boolean;
  options: KycOption[];
  visibleWhen: KycCondition[];
  matchAny: boolean;
}

export interface KycFormView {
  /** @format uuid */
  id: string;
  /** @format uuid */
  caseId: string;
  subjectName: string;
  definition: KycDefinition;
  answers: KycAnswer[];
  attachments: KycAttachmentView[];
  status: KycSubmissionStatus;
  /** @format int32 */
  revision: number;
  signingStatus?: AddoAttemptStatus | null;
  signingError?: string | null;
  signingUrl?: string | null;
  reviewFlags: string[];
  reviewReason?: string | null;
  customerMessage?: string | null;
  riskClassification?: KycRiskClassification | null;
  identityDocumentSeen: boolean;
  requiresInternalReview: boolean;
  automaticallyStopped: boolean;
  canCorrectAnswers: boolean;
  /** @format uuid */
  correctedSubmissionId?: string | null;
  /** @format date-time */
  submittedAt?: string | null;
  /** @format date-time */
  reviewedAt?: string | null;
  facts: string[];
}

export interface KycFormViewClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycFormView | null;
}

export interface KycLinkView {
  url: string;
}

export interface KycLinkViewClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycLinkView | null;
}

export interface KycOption {
  value: string;
  label: string;
}

export interface KycPreviewRequest {
  definition: KycDefinition;
  answers: KycAnswer[];
}

export interface KycReusablePerson {
  /** @format uuid */
  casePersonId: string;
  name: string;
  /** @format date-time */
  sourceDate: string;
}

export interface KycReuseAvailability {
  available: boolean;
  persons: KycReusablePerson[];
}

export interface KycReuseAvailabilityClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycReuseAvailability | null;
}

export interface KycRule {
  message: string;
  action: KycRuleAction;
  matchAny: boolean;
  conditions: KycCondition[];
}

export interface KycScreeningDecisionView {
  matchId: string;
  decision: KycMatchDecision;
  reason: string;
  /** @format uuid */
  reviewerId: string;
  /** @format date-time */
  at: string;
}

export interface KycScreeningEvidence {
  name: string;
  birthDate: string;
  searchTerms: string[];
  companyNumbers: string[];
  companyDetails: string[];
  method: string;
  sourceUrl: string;
  sourceVersion: string;
  /** @format date-time */
  sourcePublishedAt?: string | null;
  /** @format date-time */
  sourceCheckedAt?: string | null;
  message: string;
  matches: KycScreeningMatch[];
  rawResponses: string[];
}

export interface KycScreeningMatch {
  id: string;
  name: string;
  details: string[];
  sources: string[];
}

export interface KycScreeningRunView {
  /** @format uuid */
  id: string;
  source: KycScreeningSource;
  state: KycScreeningState;
  /** @format date-time */
  startedAt: string;
  /** @format date-time */
  completedAt?: string | null;
  current: boolean;
  evidence: KycScreeningEvidence;
  decisions: KycScreeningDecisionView[];
}

export interface KycScreeningView {
  canApprove: boolean;
  blockingReasons: string[];
  runs: KycScreeningRunView[];
}

export interface KycScreeningViewClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycScreeningView | null;
}

export interface KycSection {
  id: string;
  title: string;
  description: string;
  fields: KycField[];
}

export interface KycSubmissionListItem {
  requiresInternalReview: boolean;
  /** @format uuid */
  id: string;
  /** @format uuid */
  caseId: string;
  subjectName: string;
  status: KycSubmissionStatus;
  /** @format date-time */
  created: string;
}

export interface KycSubmissionListItemListClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycSubmissionListItem[] | null;
}

export interface KycTemplateView {
  /** @format uuid */
  id: string;
  /** @format int32 */
  version: number;
  /** @format int32 */
  revision: number;
  /** @format date-time */
  publishedAt?: string | null;
  definition: KycDefinition;
}

export interface KycTemplateViewClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycTemplateView | null;
}

export interface KycTemplateViewListClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: KycTemplateView[] | null;
}

export interface LoginRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @minLength 8 */
  password: string;
  /** @format uuid */
  guestChatId?: string | null;
}

export interface LoginResponse {
  token: string;
  user: UserViewObject;
}

export interface LoginResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: LoginResponse | RefreshSessionResponse | null;
}

export interface MarkChatAsReadByUserRequest {
  /** @format uuid */
  chatId: string;
}

export interface MarkLabelAsMissingRequest {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  language: string;
  /** @minLength 1 */
  location: string;
}

export interface NotificationViewModel {
  notifications: NotificationViewObject[];
}

export interface NotificationViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: NotificationViewModel | null;
}

export type NotificationViewObject = GuidEntityViewObject & {
  title: string;
  message?: string | null;
  activeFrom?: string | null;
  activeTo?: string | null;
  target?: NotificationTarget | null;
  type: NotificationType;
  alignment: NotificationAlignment;
  position: NotificationPosition;
  /** @format int32 */
  order: number;
  fullWidth: boolean;
  enabled: boolean;
};

export interface NotificationViewObjectClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: NotificationViewObject | null;
}

export interface PartnerViewModel {
  partner: PartnerViewObject;
}

export interface PartnerViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PartnerViewModel | null;
}

export type PartnerViewObject = GuidEntityViewObject & {
  name: string;
  title: string;
  description: string;
  iconUrl: string;
  websiteUrl: string;
  accentColor: string;
};

export interface PartnersViewModel {
  partners: PartnerViewObject[];
}

export interface PartnersViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PartnersViewModel | null;
}

export interface PaymentFeeViewModel {
  paymentFee: PaymentFeeViewObject;
}

export interface PaymentFeeViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PaymentFeeViewModel | null;
}

export type PaymentFeeViewObject = GuidEntityViewObject & {
  name: string;
  /** @format int32 */
  price: number;
  includeVAT: boolean;
  appliesToSoleProprietorship: boolean;
  appliesToApS: boolean;
  appliesToAS: boolean;
};

export interface PaymentFeesViewModel {
  paymentFees: PaymentFeeViewObject[];
}

export interface PaymentFeesViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PaymentFeesViewModel | null;
}

export interface PaymentProductViewModel {
  paymentProduct: PaymentProductViewObject;
}

export interface PaymentProductViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PaymentProductViewModel | null;
}

export type PaymentProductViewObject = GuidEntityViewObject & {
  requestType: FormRequestType;
  companyStructure?: CompanyStructure | null;
  companyType?: CompanyType | null;
  productName: string;
  /** @format int32 */
  price: number;
  /** @format int32 */
  lawyerPrice?: number | null;
};

export interface PaymentProductsViewModel {
  paymentProducts: PaymentProductViewObject[];
}

export interface PaymentProductsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PaymentProductsViewModel | null;
}

export interface PersonRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /**
   * @minLength 10
   * @maxLength 10
   */
  cprNumber?: string | null;
  /** @format tel */
  phoneNumber?: string | null;
  /** @minLength 1 */
  street: string;
  /** @minLength 1 */
  city: string;
  /** @minLength 1 */
  postalCode: string;
}

export interface PostalCodeInformation {
  number: string;
  name: string;
}

export interface PostalCodeSearchResponse {
  postalCodeInformations: PostalCodeInformation[];
}

export interface PostalCodeSearchResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PostalCodeSearchResponse | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface PropertyInformation {
  addressId: string;
  /** @format double */
  squareMeterSize: number;
  /** @format double */
  numberOfRooms: number;
  /** @format double */
  numberOfBathrooms: number;
  /** @format int32 */
  constructionYear: number;
  /** @format int32 */
  reconstructionYear: number;
  /** @format int32 */
  numberOfFloors: number;
}

export interface PropertyInformationResponse {
  propertyInformation?: PropertyInformation | null;
}

export interface PropertyInformationResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: PropertyInformationResponse | null;
}

export type RefreshSessionResponse = LoginResponse & object;

export interface RefreshSessionResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: RefreshSessionResponse | null;
}

export interface RegisterRequest {
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /**
   * @format email
   * @minLength 1
   */
  email: string;
  /** @format tel */
  phoneNumber?: string | null;
  /** @minLength 8 */
  password: string;
  /** @minLength 8 */
  passwordConfirm: string;
  /** @format uuid */
  guestChatId?: string | null;
}

export interface RenameChatRequest {
  /** @format uuid */
  chatId: string;
  title?: string | null;
}

export interface RequestPasswordResetRequest {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ResetPasswordForUserRequest {
  /** @format uuid */
  userId: string;
  /**
   * @minLength 8
   * @maxLength 128
   */
  password: string;
}

export interface ResetPasswordRequest {
  /** @format uuid */
  resetPasswordToken: string;
  /** @minLength 1 */
  password: string;
}

export interface ResolveAddoAttemptRequest {
  /** @format uuid */
  attemptId: string;
  /** @format int32 */
  existingSigningId?: number | null;
  confirmNoSigningExists: boolean;
}

export interface RevenueByMonthViewObject {
  periodStart: string;
  /** @format int32 */
  amount: number;
}

export interface ReviewKycRequest {
  /** @format uuid */
  submissionId: string;
  /** @format int32 */
  revision: number;
  approved: boolean;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  reason: string;
  /** @maxLength 4000 */
  customerMessage?: string | null;
  riskClassification?: KycRiskClassification | null;
  identityDocumentSeen: boolean;
}

export interface RunKycScreeningRequest {
  /** @format uuid */
  submissionId: string;
  /** @format int32 */
  revision: number;
  source: KycScreeningSource;
}

export type SaveKycAnswersRequest = KycAccessRequest & {
  /** @format int32 */
  revision: number;
  /** @maxItems 250 */
  answers: KycAnswer[];
};

export interface SaveKycTemplateRequest {
  /** @format uuid */
  id?: string | null;
  /** @format int32 */
  revision: number;
  definition: KycDefinition;
}

export interface SearchAddressResponse {
  addressId: string;
  address: string;
  street: string;
  city: string;
  postalCode: string;
  floor?: string | null;
  door?: string | null;
  /** @format double */
  x: number;
  /** @format double */
  y: number;
}

export interface SearchAddressesResponse {
  addresses: SearchAddressResponse[];
}

export interface SearchAddressesResponseClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: SearchAddressesResponse | null;
}

export interface SendChatMessageRequest {
  /** @format uuid */
  chatId: string;
  /** @minLength 1 */
  message: string;
  senderName?: string | null;
  /** @format email */
  senderEmail?: string | null;
}

export interface SetCaseSigningProvidersRequest {
  /** @format uuid */
  caseId: string;
  kycProvider: SigningProvider;
  documentSigningProvider: SigningProvider;
}

export interface StaffCaseBreakdownViewObject {
  /** @format uuid */
  userId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  role: UserRole;
  /** @format int32 */
  caseCount: number;
  /** @format int32 */
  revenue: number;
}

export interface StatisticsRequest {
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
}

export interface StatisticsViewModel {
  periodStart: string;
  periodEnd: string;
  /** @format int32 */
  totalRevenue: number;
  /** @format int32 */
  periodRevenue: number;
  /** @format int32 */
  totalPaidCases: number;
  /** @format int32 */
  paidCasesInPeriod: number;
  /** @format int32 */
  casesInPeriod: number;
  revenueByMonth: RevenueByMonthViewObject[];
  companyTypeBreakdown: CompanyTypeBreakdownViewObject[];
  staffCaseBreakdown: StaffCaseBreakdownViewObject[];
}

export interface StatisticsViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: StatisticsViewModel | null;
}

export interface StringClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: string | null;
}

export interface UpdateCasePaymentAmountRequest {
  /** @format uuid */
  caseId: string;
  /** @format int32 */
  amount: number;
}

export interface UpdateCasePersonCompanyParticipantRequest {
  /** @format uuid */
  casePersonCompanyParticipantId: string;
  isPep?: boolean | null;
  sourceOfFunds?: string | null;
}

export interface UpdateCasePersonKycLinkTemplateRequest {
  /**
   * @minLength 1
   * @maxLength 50000
   */
  casePersonKycLinkTemplate: string;
}

export interface UpdateCasePersonParticipantsKycLinkTemplateRequest {
  /**
   * @minLength 1
   * @maxLength 50000
   */
  casePersonParticipantsKycLinkTemplate: string;
}

export interface UpdateCasePersonRequest {
  /** @format uuid */
  casePersonId: string;
  isPep?: boolean | null;
  sourceOfFunds?: string | null;
}

export interface UpdateCaseStepRequest {
  /** @format uuid */
  caseId: string;
  step: CaseStep;
  completed: boolean;
  cvrNumber?: string | null;
  bankRegNumber?: string | null;
  bankAccountNumber?: string | null;
  iban?: string | null;
  bicSwift?: string | null;
}

export type UpdateCouponRequest = CreateCouponRequest & {
  /** @minLength 1 */
  couponId: string;
};

export interface UpdateDataLonIntegrationRequest {
  enabled: boolean;
}

export interface UpdateDictionaryLabelRequest {
  /** @minLength 1 */
  key: string;
  area?: string | null;
  textsByLanguages: UpdateDictionaryLabelRequestTextByLanguage[];
}

export interface UpdateDictionaryLabelRequestTextByLanguage {
  /** @minLength 1 */
  languageCode: string;
  text: string;
  contentType: DictionaryLabelContentType;
}

export interface UpdateEmailFooterTemplateRequest {
  /**
   * @minLength 1
   * @maxLength 50000
   */
  footerTemplate: string;
}

export interface UpdateEmailTriggerFlowServiceEnabledRequest {
  emailTriggerFlowServiceEnabled: boolean;
}

export interface UpdateFormConsentRequest {
  /** @format uuid */
  formConsentId: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 5000
   */
  text: string;
  /** @format int32 */
  sortOrder: number;
  showForApS: boolean;
  showForAS: boolean;
  showForSoleProprietorship: boolean;
}

export interface UpdateFormTermsTemplateRequest {
  /**
   * @minLength 1
   * @maxLength 50000
   */
  termsTemplate: string;
}

export interface UpdatePartnerRequest {
  /** @format uuid */
  partnerId: string;
  /** @minLength 1 */
  name: string;
  /** @minLength 1 */
  title: string;
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  iconUrl: string;
  /** @minLength 1 */
  websiteUrl: string;
  /** @minLength 1 */
  accentColor: string;
}

export interface UpdatePaymentFeeRequest {
  /** @format uuid */
  paymentFeeId: string;
  /** @minLength 1 */
  name: string;
  /** @format int32 */
  price: number;
  includeVAT: boolean;
  appliesToSoleProprietorship: boolean;
  appliesToApS: boolean;
  appliesToAS: boolean;
}

export interface UpdatePaymentProductRequest {
  /** @format uuid */
  paymentProductId: string;
  /** @minLength 1 */
  productName: string;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  price: number;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  lawyerPrice?: number | null;
}

export type UpdateUserRequest = CreateUserRequest & {
  /** @format uuid */
  userId: string;
};

export interface UploadBankAccountDocumentRequest {
  /** @format uuid */
  caseId: string;
  bankRegNumber?: string | null;
  bankAccountNumber?: string | null;
  iban?: string | null;
  bicSwift?: string | null;
  file: Base64EncodedFile;
}

export interface UploadCasePersonAddressDocumentRequest {
  /** @format uuid */
  casePersonId: string;
  file: Base64EncodedFile;
}

export interface UploadCasePersonCompanyParticipantAddressDocumentRequest {
  /** @format uuid */
  casePersonCompanyParticipantId: string;
  file: Base64EncodedFile;
}

export interface UploadCasePersonCompanyParticipantKycDocumentRequest {
  /** @format uuid */
  casePersonCompanyParticipantId: string;
  file: Base64EncodedFile;
}

export interface UploadCasePersonKycDocumentRequest {
  /** @format uuid */
  casePersonId: string;
  file: Base64EncodedFile;
}

export type UploadKycAttachmentRequest = KycAccessRequest & {
  /**
   * @minLength 1
   * @maxLength 100
   */
  fieldId: string;
  /**
   * @minLength 1
   * @maxLength 255
   */
  fileName: string;
  /** @minLength 1 */
  data: string;
};

export interface UploadSelskabsDocumentRequest {
  /** @format uuid */
  caseId: string;
  file: Base64EncodedFile;
}

export interface UserLoginHistoryViewModel {
  loginHistories: UserLoginHistoryViewObject[];
}

export interface UserLoginHistoryViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: UserLoginHistoryViewModel | null;
}

export interface UserLoginHistoryViewObject {
  /** @format uuid */
  userId: string;
  ip: string;
  date: string;
  logoutDate?: string | null;
  /** @format int32 */
  sessionDuration?: number | null;
}

export interface UserSearchFilter {
  searchTerm?: string | null;
  role?: UserRole | null;
  /**
   * @format int32
   * @min 1
   * @max 2147483647
   */
  page: number;
  /**
   * @format int32
   * @min 1
   * @max 100
   */
  pageSize: number;
  sortBy: UserSearchSortBy;
  desc: boolean;
  includeDeleted: boolean;
}

export interface UserViewModel {
  user: UserViewObject;
}

export interface UserViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: UserViewModel | null;
}

export type UserViewObject = GuidEntityViewObject & {
  name: string;
  email: string;
  phone?: string | null;
  lastName: string;
  fullName: string;
  blocked: boolean;
  emailVerified: boolean;
  deletedSince?: string | null;
  isStaff: boolean;
  lastLogin?: string | null;
  lastIp?: string | null;
  profileImageUrl?: string | null;
  logoImageUrl?: string | null;
  role: UserRole;
  allowableIps: string[];
  /** @format uuid */
  groupChatId: string;
  activeConnections?: HubConnectionViewObject[] | null;
};

export interface UsersByIdRequest {
  userIds: string[];
}

export interface UsersSearchViewModel {
  users: UserViewObject[];
  /** @format int32 */
  totalCount: number;
}

export interface UsersSearchViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: UsersSearchViewModel | null;
}

export interface UsersViewModel {
  users: UserViewObject[];
}

export interface UsersViewModelClientResponse {
  validationMessages?: ValidationMessage[] | null;
  correlationId?: string | null;
  /** @format double */
  serverTimeMs?: number | null;
  model?: UsersViewModel | null;
}

export interface ValidationMessage {
  message: string;
  args?: any[] | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Stiftselskab API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignConfiguredList
     * @request GET:/api/AddoSign/Configured
     * @secure
     */
    addoSignConfiguredList: (params: RequestParams = {}) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/AddoSign/Configured`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignAttemptsList
     * @request GET:/api/AddoSign/Attempts
     * @secure
     */
    addoSignAttemptsList: (params: RequestParams = {}) =>
      this.request<AddoAttemptViewListClientResponse, any>({
        path: `/api/AddoSign/Attempts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignRestartCreate
     * @request POST:/api/AddoSign/Restart
     * @secure
     */
    addoSignRestartCreate: (
      query?: {
        /** @format uuid */
        attemptId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/AddoSign/Restart`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignSetCaseProvidersCreate
     * @request POST:/api/AddoSign/SetCaseProviders
     * @secure
     */
    addoSignSetCaseProvidersCreate: (
      data: SetCaseSigningProvidersRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/AddoSign/SetCaseProviders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignResolveCreate
     * @request POST:/api/AddoSign/Resolve
     * @secure
     */
    addoSignResolveCreate: (
      data: ResolveAddoAttemptRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/AddoSign/Resolve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AddoSign
     * @name AddoSignCallbackList
     * @request GET:/api/AddoSign/Callback
     * @secure
     */
    addoSignCallbackList: (
      query?: {
        /** @format int32 */
        signingId?: number;
        key?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/AddoSign/Callback`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthLoginCreate
     * @request POST:/api/Auth/Login
     * @secure
     */
    authLoginCreate: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<
        LoginResponseClientResponse,
        ProblemDetails | HttpValidationProblemDetails
      >({
        path: `/api/Auth/Login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRegisterCreate
     * @request POST:/api/Auth/Register
     * @secure
     */
    authRegisterCreate: (data: RegisterRequest, params: RequestParams = {}) =>
      this.request<
        LoginResponseClientResponse,
        ProblemDetails | HttpValidationProblemDetails
      >({
        path: `/api/Auth/Register`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRefreshSessionList
     * @request GET:/api/Auth/RefreshSession
     * @secure
     */
    authRefreshSessionList: (params: RequestParams = {}) =>
      this.request<
        RefreshSessionResponseClientResponse,
        ProblemDetails | HttpValidationProblemDetails
      >({
        path: `/api/Auth/RefreshSession`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthChangePasswordCreate
     * @request POST:/api/Auth/ChangePassword
     * @secure
     */
    authChangePasswordCreate: (
      data: ChangePasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<RefreshSessionResponseClientResponse, any>({
        path: `/api/Auth/ChangePassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRequestPasswordResetCreate
     * @request POST:/api/Auth/RequestPasswordReset
     * @secure
     */
    authRequestPasswordResetCreate: (
      data: RequestPasswordResetRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Auth/RequestPasswordReset`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthResetPasswordCreate
     * @request POST:/api/Auth/ResetPassword
     * @secure
     */
    authResetPasswordCreate: (
      data: ResetPasswordRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Auth/ResetPassword`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRequestEmailVerificationCreate
     * @request POST:/api/Auth/RequestEmailVerification
     * @secure
     */
    authRequestEmailVerificationCreate: (params: RequestParams = {}) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Auth/RequestEmailVerification`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthVerifyEmailList
     * @request GET:/api/Auth/VerifyEmail
     * @secure
     */
    authVerifyEmailList: (
      query?: {
        /** @format uuid */
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Auth/VerifyEmail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetActiveList
     * @request GET:/api/Cases/GetActive
     * @secure
     */
    casesGetActiveList: (params: RequestParams = {}) =>
      this.request<CasesViewModelClientResponse, any>({
        path: `/api/Cases/GetActive`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetClosedList
     * @request GET:/api/Cases/GetClosed
     * @secure
     */
    casesGetClosedList: (params: RequestParams = {}) =>
      this.request<CasesViewModelClientResponse, any>({
        path: `/api/Cases/GetClosed`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetCaseList
     * @request GET:/api/Cases/GetCase
     * @secure
     */
    casesGetCaseList: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/GetCase`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeleteCaseCreate
     * @request POST:/api/Cases/DeleteCase
     * @secure
     */
    casesDeleteCaseCreate: (
      query: {
        /** @format uuid */
        caseId: string;
        /** @default false */
        deleteLinkedLockedCases?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/DeleteCase`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetFilesList
     * @request GET:/api/Cases/GetFiles
     * @secure
     */
    casesGetFilesList: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseFilesViewModelClientResponse, any>({
        path: `/api/Cases/GetFiles`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetEventsList
     * @request GET:/api/Cases/GetEvents
     * @secure
     */
    casesGetEventsList: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseEventLogsViewModelClientResponse, any>({
        path: `/api/Cases/GetEvents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadFileUpdate
     * @request PUT:/api/Cases/UploadFile
     * @secure
     */
    casesUploadFileUpdate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseFileViewModelClientResponse, any>({
        path: `/api/Cases/UploadFile`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeleteFileDelete
     * @request DELETE:/api/Cases/DeleteFile
     * @secure
     */
    casesDeleteFileDelete: (
      query: {
        /** @format uuid */
        caseFileId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Cases/DeleteFile`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadBankAccountDocumentCreate
     * @request POST:/api/Cases/UploadBankAccountDocument
     * @secure
     */
    casesUploadBankAccountDocumentCreate: (
      data: UploadBankAccountDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/UploadBankAccountDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadSelskabsDocumentCreate
     * @request POST:/api/Cases/UploadSelskabsDocument
     * @secure
     */
    casesUploadSelskabsDocumentCreate: (
      data: UploadSelskabsDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/UploadSelskabsDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeleteSelskabsmappeCreate
     * @request POST:/api/Cases/DeleteSelskabsmappe
     * @secure
     */
    casesDeleteSelskabsmappeCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/DeleteSelskabsmappe`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesApproveBankAccountDocumentCreate
     * @request POST:/api/Cases/ApproveBankAccountDocument
     * @secure
     */
    casesApproveBankAccountDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/ApproveBankAccountDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeclineBankAccountDocumentCreate
     * @request POST:/api/Cases/DeclineBankAccountDocument
     * @secure
     */
    casesDeclineBankAccountDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/DeclineBankAccountDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesMarkCapitalTransferCreate
     * @request POST:/api/Cases/MarkCapitalTransfer
     * @secure
     */
    casesMarkCapitalTransferCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/MarkCapitalTransfer`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesAcceptCapitalTransferCreate
     * @request POST:/api/Cases/AcceptCapitalTransfer
     * @secure
     */
    casesAcceptCapitalTransferCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/AcceptCapitalTransfer`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeclineCapitalTransferCreate
     * @request POST:/api/Cases/DeclineCapitalTransfer
     * @secure
     */
    casesDeclineCapitalTransferCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/DeclineCapitalTransfer`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesMarkCapitalTransferReturnedCreate
     * @request POST:/api/Cases/MarkCapitalTransferReturned
     * @secure
     */
    casesMarkCapitalTransferReturnedCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/MarkCapitalTransferReturned`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetPersonsList
     * @request GET:/api/Cases/GetPersons
     * @secure
     */
    casesGetPersonsList: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonsViewModelClientResponse, any>({
        path: `/api/Cases/GetPersons`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetPersonList
     * @request GET:/api/Cases/GetPerson
     * @secure
     */
    casesGetPersonList: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/GetPerson`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUpdatePersonCreate
     * @request POST:/api/Cases/UpdatePerson
     * @secure
     */
    casesUpdatePersonCreate: (
      data: UpdateCasePersonRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/UpdatePerson`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesInitiatePersonVerificationCreate
     * @request POST:/api/Cases/InitiatePersonVerification
     * @secure
     */
    casesInitiatePersonVerificationCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InitiateCasePersonVerificationViewModelClientResponse, any>({
        path: `/api/Cases/InitiatePersonVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadPersonKycDocumentCreate
     * @request POST:/api/Cases/UploadPersonKycDocument
     * @secure
     */
    casesUploadPersonKycDocumentCreate: (
      data: UploadCasePersonKycDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/UploadPersonKycDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadPersonAddressDocumentCreate
     * @request POST:/api/Cases/UploadPersonAddressDocument
     * @secure
     */
    casesUploadPersonAddressDocumentCreate: (
      data: UploadCasePersonAddressDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/UploadPersonAddressDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesApprovePersonAddressDocumentCreate
     * @request POST:/api/Cases/ApprovePersonAddressDocument
     * @secure
     */
    casesApprovePersonAddressDocumentCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/ApprovePersonAddressDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeclinePersonAddressDocumentCreate
     * @request POST:/api/Cases/DeclinePersonAddressDocument
     * @secure
     */
    casesDeclinePersonAddressDocumentCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/DeclinePersonAddressDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCheckPersonVerificationCreate
     * @request POST:/api/Cases/CheckPersonVerification
     * @secure
     */
    casesCheckPersonVerificationCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/Cases/CheckPersonVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetParticipantList
     * @request GET:/api/Cases/GetParticipant
     * @secure
     */
    casesGetParticipantList: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/GetParticipant`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUpdateParticipantCreate
     * @request POST:/api/Cases/UpdateParticipant
     * @secure
     */
    casesUpdateParticipantCreate: (
      data: UpdateCasePersonCompanyParticipantRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/UpdateParticipant`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesInitiateParticipantVerificationCreate
     * @request POST:/api/Cases/InitiateParticipantVerification
     * @secure
     */
    casesInitiateParticipantVerificationCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        InitiateCasePersonCompanyParticipantVerificationViewModelClientResponse,
        any
      >({
        path: `/api/Cases/InitiateParticipantVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadParticipantKycDocumentCreate
     * @request POST:/api/Cases/UploadParticipantKycDocument
     * @secure
     */
    casesUploadParticipantKycDocumentCreate: (
      data: UploadCasePersonCompanyParticipantKycDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/UploadParticipantKycDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUploadParticipantAddressDocumentCreate
     * @request POST:/api/Cases/UploadParticipantAddressDocument
     * @secure
     */
    casesUploadParticipantAddressDocumentCreate: (
      data: UploadCasePersonCompanyParticipantAddressDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/UploadParticipantAddressDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesApproveParticipantAddressDocumentCreate
     * @request POST:/api/Cases/ApproveParticipantAddressDocument
     * @secure
     */
    casesApproveParticipantAddressDocumentCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/ApproveParticipantAddressDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesDeclineParticipantAddressDocumentCreate
     * @request POST:/api/Cases/DeclineParticipantAddressDocument
     * @secure
     */
    casesDeclineParticipantAddressDocumentCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/DeclineParticipantAddressDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCheckParticipantVerificationCreate
     * @request POST:/api/Cases/CheckParticipantVerification
     * @secure
     */
    casesCheckParticipantVerificationCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/Cases/CheckParticipantVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesSendVerificationLinkCreate
     * @request POST:/api/Cases/SendVerificationLink
     * @secure
     */
    casesSendVerificationLinkCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Cases/SendVerificationLink`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesSendCompanyParticipantsVerificationLinkCreate
     * @request POST:/api/Cases/SendCompanyParticipantsVerificationLink
     * @secure
     */
    casesSendCompanyParticipantsVerificationLinkCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Cases/SendCompanyParticipantsVerificationLink`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesSendDocumentSigningEmailCreate
     * @request POST:/api/Cases/SendDocumentSigningEmail
     * @secure
     */
    casesSendDocumentSigningEmailCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Cases/SendDocumentSigningEmail`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesSendDocumentSigningEmailToPendingCreate
     * @request POST:/api/Cases/SendDocumentSigningEmailToPending
     * @secure
     */
    casesSendDocumentSigningEmailToPendingCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Cases/SendDocumentSigningEmailToPending`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCreatePaymentCreate
     * @request POST:/api/Cases/CreatePayment
     * @secure
     */
    casesCreatePaymentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StringClientResponse, any>({
        path: `/api/Cases/CreatePayment`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCheckPaymentStatusCreate
     * @request POST:/api/Cases/CheckPaymentStatus
     * @secure
     */
    casesCheckPaymentStatusCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/CheckPaymentStatus`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetPaymentDocumentUrlCreate
     * @request POST:/api/Cases/GetPaymentDocumentUrl
     * @secure
     */
    casesGetPaymentDocumentUrlCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<StringClientResponse, any>({
        path: `/api/Cases/GetPaymentDocumentUrl`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUpdatePaymentAmountCreate
     * @request POST:/api/Cases/UpdatePaymentAmount
     * @secure
     */
    casesUpdatePaymentAmountCreate: (
      data: UpdateCasePaymentAmountRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/UpdatePaymentAmount`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGenerateDocumentCreate
     * @request POST:/api/Cases/GenerateDocument
     * @secure
     */
    casesGenerateDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
        regenerateIfExists: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/GenerateDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGenerateEjerbogDocumentCreate
     * @request POST:/api/Cases/GenerateEjerbogDocument
     * @secure
     */
    casesGenerateEjerbogDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
        regenerateIfExists: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/GenerateEjerbogDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGenerateSelskabsmappeDocumentCreate
     * @request POST:/api/Cases/GenerateSelskabsmappeDocument
     * @secure
     */
    casesGenerateSelskabsmappeDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
        regenerateIfExists: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/GenerateSelskabsmappeDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGenerateKycVerificationDocumentCreate
     * @request POST:/api/Cases/GenerateKycVerificationDocument
     * @secure
     */
    casesGenerateKycVerificationDocumentCreate: (
      query: {
        /** @format uuid */
        caseId: string;
        regenerateIfExists: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/GenerateKycVerificationDocument`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesGetReusableKycCreate
     * @request POST:/api/Cases/GetReusableKyc
     * @secure
     */
    casesGetReusableKycCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycReuseAvailabilityClientResponse, any>({
        path: `/api/Cases/GetReusableKyc`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesReusePreviousKycCreate
     * @request POST:/api/Cases/ReusePreviousKyc
     * @secure
     */
    casesReusePreviousKycCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/ReusePreviousKyc`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCreateDocumentSigningOrderCreate
     * @request POST:/api/Cases/CreateDocumentSigningOrder
     * @secure
     */
    casesCreateDocumentSigningOrderCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/CreateDocumentSigningOrder`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesCheckDocumentSigningStatusCreate
     * @request POST:/api/Cases/CheckDocumentSigningStatus
     * @secure
     */
    casesCheckDocumentSigningStatusCreate: (
      query: {
        /** @format uuid */
        caseId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/CheckDocumentSigningStatus`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesUpdateStepCreate
     * @request POST:/api/Cases/UpdateStep
     * @secure
     */
    casesUpdateStepCreate: (
      data: UpdateCaseStepRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewModelClientResponse, any>({
        path: `/api/Cases/UpdateStep`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cases
     * @name CasesSearchCreate
     * @request POST:/api/Cases/Search
     * @secure
     */
    casesSearchCreate: (data: CaseSearchFilter, params: RequestParams = {}) =>
      this.request<CasesSearchViewModelClientResponse, any>({
        path: `/api/Cases/Search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationGetCasePersonList
     * @request GET:/api/CaseVerification/GetCasePerson
     * @secure
     */
    caseVerificationGetCasePersonList: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewObjectClientResponse, any>({
        path: `/api/CaseVerification/GetCasePerson`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationUpdatePersonCreate
     * @request POST:/api/CaseVerification/UpdatePerson
     * @secure
     */
    caseVerificationUpdatePersonCreate: (
      data: UpdateCasePersonRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/CaseVerification/UpdatePerson`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationInitiatePersonVerificationCreate
     * @request POST:/api/CaseVerification/InitiatePersonVerification
     * @secure
     */
    caseVerificationInitiatePersonVerificationCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InitiateCasePersonVerificationViewModelClientResponse, any>({
        path: `/api/CaseVerification/InitiatePersonVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationUploadPersonAddressDocumentCreate
     * @request POST:/api/CaseVerification/UploadPersonAddressDocument
     * @secure
     */
    caseVerificationUploadPersonAddressDocumentCreate: (
      data: UploadCasePersonAddressDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/CaseVerification/UploadPersonAddressDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationCheckPersonVerificationCreate
     * @request POST:/api/CaseVerification/CheckPersonVerification
     * @secure
     */
    caseVerificationCheckPersonVerificationCreate: (
      query: {
        /** @format uuid */
        casePersonId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonViewModelClientResponse, any>({
        path: `/api/CaseVerification/CheckPersonVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationGetCaseParticipantList
     * @request GET:/api/CaseVerification/GetCaseParticipant
     * @secure
     */
    caseVerificationGetCaseParticipantList: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewObjectClientResponse, any>({
        path: `/api/CaseVerification/GetCaseParticipant`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationUpdateParticipantCreate
     * @request POST:/api/CaseVerification/UpdateParticipant
     * @secure
     */
    caseVerificationUpdateParticipantCreate: (
      data: UpdateCasePersonCompanyParticipantRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/CaseVerification/UpdateParticipant`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationInitiateParticipantVerificationCreate
     * @request POST:/api/CaseVerification/InitiateParticipantVerification
     * @secure
     */
    caseVerificationInitiateParticipantVerificationCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        InitiateCasePersonCompanyParticipantVerificationViewModelClientResponse,
        any
      >({
        path: `/api/CaseVerification/InitiateParticipantVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationUploadParticipantAddressDocumentCreate
     * @request POST:/api/CaseVerification/UploadParticipantAddressDocument
     * @secure
     */
    caseVerificationUploadParticipantAddressDocumentCreate: (
      data: UploadCasePersonCompanyParticipantAddressDocumentRequest,
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/CaseVerification/UploadParticipantAddressDocument`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags CaseVerification
     * @name CaseVerificationCheckParticipantVerificationCreate
     * @request POST:/api/CaseVerification/CheckParticipantVerification
     * @secure
     */
    caseVerificationCheckParticipantVerificationCreate: (
      query: {
        /** @format uuid */
        caseParticipantId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CasePersonCompanyParticipantViewModelClientResponse, any>({
        path: `/api/CaseVerification/CheckParticipantVerification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationSendChatMessageCreate
     * @request POST:/api/Communication/SendChatMessage
     * @secure
     */
    communicationSendChatMessageCreate: (
      data: SendChatMessageRequest,
      params: RequestParams = {},
    ) =>
      this.request<GroupChatMessageViewObjectClientResponse, any>({
        path: `/api/Communication/SendChatMessage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationMarkChatAsReadByUserCreate
     * @request POST:/api/Communication/MarkChatAsReadByUser
     * @secure
     */
    communicationMarkChatAsReadByUserCreate: (
      data: MarkChatAsReadByUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/MarkChatAsReadByUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationCreateChatCreate
     * @request POST:/api/Communication/CreateChat
     * @secure
     */
    communicationCreateChatCreate: (
      data: CreateChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/CreateChat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationDeleteChatCreate
     * @request POST:/api/Communication/DeleteChat
     * @secure
     */
    communicationDeleteChatCreate: (
      data: DeleteChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/DeleteChat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationRenameChatCreate
     * @request POST:/api/Communication/RenameChat
     * @secure
     */
    communicationRenameChatCreate: (
      data: RenameChatRequest,
      params: RequestParams = {},
    ) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/RenameChat`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationGetChatList
     * @request GET:/api/Communication/GetChat
     * @secure
     */
    communicationGetChatList: (
      query: {
        /** @format uuid */
        chatId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/GetChat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationGetChatsList
     * @request GET:/api/Communication/GetChats
     * @secure
     */
    communicationGetChatsList: (params: RequestParams = {}) =>
      this.request<GroupChatViewModelClientResponse, any>({
        path: `/api/Communication/GetChats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationCreateGuestChatCreate
     * @request POST:/api/Communication/CreateGuestChat
     * @secure
     */
    communicationCreateGuestChatCreate: (params: RequestParams = {}) =>
      this.request<GroupChatViewObjectClientResponse, any>({
        path: `/api/Communication/CreateGuestChat`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationGetSupportChatsList
     * @request GET:/api/Communication/GetSupportChats
     * @secure
     */
    communicationGetSupportChatsList: (params: RequestParams = {}) =>
      this.request<GroupChatViewModelClientResponse, any>({
        path: `/api/Communication/GetSupportChats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Communication
     * @name CommunicationGetMessagesForChatList
     * @request GET:/api/Communication/GetMessagesForChat
     * @secure
     */
    communicationGetMessagesForChatList: (
      query: {
        /** @format uuid */
        chatId: string;
        /** @format int32 */
        skip: number;
        /** @format int32 */
        take: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GroupChatMessagesViewModelClientResponse, any>({
        path: `/api/Communication/GetMessagesForChat`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name CouponsGetCouponsList
     * @request GET:/api/Coupons/GetCoupons
     * @secure
     */
    couponsGetCouponsList: (params: RequestParams = {}) =>
      this.request<CouponsViewModelClientResponse, any>({
        path: `/api/Coupons/GetCoupons`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name CouponsCreateCouponCreate
     * @request POST:/api/Coupons/CreateCoupon
     * @secure
     */
    couponsCreateCouponCreate: (
      data: CreateCouponRequest | UpdateCouponRequest,
      params: RequestParams = {},
    ) =>
      this.request<CouponViewObjectClientResponse, any>({
        path: `/api/Coupons/CreateCoupon`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name CouponsUpdateCouponCreate
     * @request POST:/api/Coupons/UpdateCoupon
     * @secure
     */
    couponsUpdateCouponCreate: (
      data: UpdateCouponRequest,
      params: RequestParams = {},
    ) =>
      this.request<CouponViewObjectClientResponse, any>({
        path: `/api/Coupons/UpdateCoupon`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Coupons
     * @name CouponsDeleteCouponDelete
     * @request DELETE:/api/Coupons/DeleteCoupon
     * @secure
     */
    couponsDeleteCouponDelete: (
      query?: {
        couponId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Coupons/DeleteCoupon`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cvr
     * @name CvrGetBranchesList
     * @request GET:/api/Cvr/GetBranches
     * @secure
     */
    cvrGetBranchesList: (params: RequestParams = {}) =>
      this.request<BrancheNodeArrayClientResponse, any>({
        path: `/api/Cvr/GetBranches`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryCacheBustList
     * @request GET:/api/Dictionary/CacheBust
     * @secure
     */
    dictionaryCacheBustList: (params: RequestParams = {}) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Dictionary/CacheBust`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryCacheBustCreate
     * @request POST:/api/Dictionary/CacheBust
     * @secure
     */
    dictionaryCacheBustCreate: (params: RequestParams = {}) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Dictionary/CacheBust`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetSupportedAdminLanguagesList
     * @request GET:/api/Dictionary/GetSupportedAdminLanguages
     * @secure
     */
    dictionaryGetSupportedAdminLanguagesList: (params: RequestParams = {}) =>
      this.request<DictionaryLanguagesViewModelClientResponse, any>({
        path: `/api/Dictionary/GetSupportedAdminLanguages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetAdminDictionaryLabelsForAreaList
     * @request GET:/api/Dictionary/GetAdminDictionaryLabelsForArea
     * @secure
     */
    dictionaryGetAdminDictionaryLabelsForAreaList: (
      query?: {
        area?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLabelsViewModelClientResponse, any>({
        path: `/api/Dictionary/GetAdminDictionaryLabelsForArea`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetAdminDictionaryLabelsList
     * @request GET:/api/Dictionary/GetAdminDictionaryLabels
     * @secure
     */
    dictionaryGetAdminDictionaryLabelsList: (params: RequestParams = {}) =>
      this.request<DictionaryLabelsByLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/GetAdminDictionaryLabels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetSupportedShopLanguagesList
     * @request GET:/api/Dictionary/GetSupportedShopLanguages
     * @secure
     */
    dictionaryGetSupportedShopLanguagesList: (params: RequestParams = {}) =>
      this.request<DictionaryLanguagesViewModelClientResponse, any>({
        path: `/api/Dictionary/GetSupportedShopLanguages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetShopDictionaryLabelsForAreaList
     * @request GET:/api/Dictionary/GetShopDictionaryLabelsForArea
     * @secure
     */
    dictionaryGetShopDictionaryLabelsForAreaList: (
      query?: {
        area?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLabelsViewModelClientResponse, any>({
        path: `/api/Dictionary/GetShopDictionaryLabelsForArea`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryGetShopDictionaryLabelsList
     * @request GET:/api/Dictionary/GetShopDictionaryLabels
     * @secure
     */
    dictionaryGetShopDictionaryLabelsList: (params: RequestParams = {}) =>
      this.request<DictionaryLabelsByLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/GetShopDictionaryLabels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryMarkAdminLabelAsMissingCreate
     * @request POST:/api/Dictionary/MarkAdminLabelAsMissing
     * @secure
     */
    dictionaryMarkAdminLabelAsMissingCreate: (
      data: MarkLabelAsMissingRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Dictionary/MarkAdminLabelAsMissing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryMarkShopLabelAsMissingCreate
     * @request POST:/api/Dictionary/MarkShopLabelAsMissing
     * @secure
     */
    dictionaryMarkShopLabelAsMissingCreate: (
      data: MarkLabelAsMissingRequest,
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Dictionary/MarkShopLabelAsMissing`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryAddOrUpdateAdminDictionaryLabelCreate
     * @request POST:/api/Dictionary/AddOrUpdateAdminDictionaryLabel
     * @secure
     */
    dictionaryAddOrUpdateAdminDictionaryLabelCreate: (
      data: UpdateDictionaryLabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLabelByLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/AddOrUpdateAdminDictionaryLabel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryAddOrUpdateAdminDictionaryLanguageCreate
     * @request POST:/api/Dictionary/AddOrUpdateAdminDictionaryLanguage
     * @secure
     */
    dictionaryAddOrUpdateAdminDictionaryLanguageCreate: (
      data: AddOrUpdateDictionaryLanguageRequest,
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/AddOrUpdateAdminDictionaryLanguage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryAddOrUpdateShopDictionaryLabelCreate
     * @request POST:/api/Dictionary/AddOrUpdateShopDictionaryLabel
     * @secure
     */
    dictionaryAddOrUpdateShopDictionaryLabelCreate: (
      data: UpdateDictionaryLabelRequest,
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLabelByLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/AddOrUpdateShopDictionaryLabel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dictionary
     * @name DictionaryAddOrUpdateShopDictionaryLanguageCreate
     * @request POST:/api/Dictionary/AddOrUpdateShopDictionaryLanguage
     * @secure
     */
    dictionaryAddOrUpdateShopDictionaryLanguageCreate: (
      data: AddOrUpdateDictionaryLanguageRequest,
      params: RequestParams = {},
    ) =>
      this.request<DictionaryLanguageViewModelClientResponse, any>({
        path: `/api/Dictionary/AddOrUpdateShopDictionaryLanguage`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentTemplates
     * @name DocumentTemplatesListList
     * @request GET:/api/DocumentTemplates/List
     * @secure
     */
    documentTemplatesListList: (
      query: {
        type: DocumentTemplateType;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentTemplatesViewModelClientResponse, any>({
        path: `/api/DocumentTemplates/List`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentTemplates
     * @name DocumentTemplatesUploadUpdate
     * @request PUT:/api/DocumentTemplates/Upload
     * @secure
     */
    documentTemplatesUploadUpdate: (
      query: {
        type: DocumentTemplateType;
        regenerate?: boolean;
      },
      data: {
        /** @format binary */
        file: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<DocumentTemplateFileViewObjectClientResponse, any>({
        path: `/api/DocumentTemplates/Upload`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentTemplates
     * @name DocumentTemplatesDownloadList
     * @request GET:/api/DocumentTemplates/Download
     * @secure
     */
    documentTemplatesDownloadList: (
      query: {
        type: DocumentTemplateType;
        fileName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/DocumentTemplates/Download`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DocumentTemplates
     * @name DocumentTemplatesViewPdfList
     * @request GET:/api/DocumentTemplates/ViewPdf
     * @secure
     */
    documentTemplatesViewPdfList: (
      query: {
        type: DocumentTemplateType;
        fileName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/DocumentTemplates/ViewPdf`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailFlows
     * @name EmailFlowsGetFlowsList
     * @request GET:/api/EmailFlows/GetFlows
     * @secure
     */
    emailFlowsGetFlowsList: (params: RequestParams = {}) =>
      this.request<EmailFlowsViewModelClientResponse, any>({
        path: `/api/EmailFlows/GetFlows`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailFlows
     * @name EmailFlowsAddOrUpdateFlowCreate
     * @request POST:/api/EmailFlows/AddOrUpdateFlow
     * @secure
     */
    emailFlowsAddOrUpdateFlowCreate: (
      data: AddOrUpdateEmailFlowRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailFlowViewModelClientResponse, any>({
        path: `/api/EmailFlows/AddOrUpdateFlow`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailFlows
     * @name EmailFlowsDeleteFlowDelete
     * @request DELETE:/api/EmailFlows/DeleteFlow
     * @secure
     */
    emailFlowsDeleteFlowDelete: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmailFlowViewModelClientResponse, any>({
        path: `/api/EmailFlows/DeleteFlow`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsGetSettingsList
     * @request GET:/api/EmailSettings/GetSettings
     * @secure
     */
    emailSettingsGetSettingsList: (params: RequestParams = {}) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/GetSettings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdateFooterTemplateCreate
     * @request POST:/api/EmailSettings/UpdateFooterTemplate
     * @secure
     */
    emailSettingsUpdateFooterTemplateCreate: (
      data: UpdateEmailFooterTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/UpdateFooterTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdateCasePersonKycLinkTemplateCreate
     * @request POST:/api/EmailSettings/UpdateCasePersonKycLinkTemplate
     * @secure
     */
    emailSettingsUpdateCasePersonKycLinkTemplateCreate: (
      data: UpdateCasePersonKycLinkTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/UpdateCasePersonKycLinkTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdateCasePersonParticipantsKycLinkTemplateCreate
     * @request POST:/api/EmailSettings/UpdateCasePersonParticipantsKycLinkTemplate
     * @secure
     */
    emailSettingsUpdateCasePersonParticipantsKycLinkTemplateCreate: (
      data: UpdateCasePersonParticipantsKycLinkTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/UpdateCasePersonParticipantsKycLinkTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdateEmailTriggerFlowServiceEnabledCreate
     * @request POST:/api/EmailSettings/UpdateEmailTriggerFlowServiceEnabled
     * @secure
     */
    emailSettingsUpdateEmailTriggerFlowServiceEnabledCreate: (
      data: UpdateEmailTriggerFlowServiceEnabledRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/UpdateEmailTriggerFlowServiceEnabled`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailSettings
     * @name EmailSettingsUpdateFormTermsTemplateCreate
     * @request POST:/api/EmailSettings/UpdateFormTermsTemplate
     * @secure
     */
    emailSettingsUpdateFormTermsTemplateCreate: (
      data: UpdateFormTermsTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<EmailSettingsViewModelClientResponse, any>({
        path: `/api/EmailSettings/UpdateFormTermsTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormConsents
     * @name FormConsentsGetActiveFormConsentsList
     * @request GET:/api/FormConsents/GetActiveFormConsents
     * @secure
     */
    formConsentsGetActiveFormConsentsList: (
      query?: {
        requestType?: FormRequestType;
        companyType?: CompanyType;
      },
      params: RequestParams = {},
    ) =>
      this.request<FormConsentsViewModelClientResponse, any>({
        path: `/api/FormConsents/GetActiveFormConsents`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormConsents
     * @name FormConsentsGetFormConsentsList
     * @request GET:/api/FormConsents/GetFormConsents
     * @secure
     */
    formConsentsGetFormConsentsList: (params: RequestParams = {}) =>
      this.request<FormConsentsViewModelClientResponse, any>({
        path: `/api/FormConsents/GetFormConsents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormConsents
     * @name FormConsentsAddFormConsentCreate
     * @request POST:/api/FormConsents/AddFormConsent
     * @secure
     */
    formConsentsAddFormConsentCreate: (
      data: AddFormConsentRequest,
      params: RequestParams = {},
    ) =>
      this.request<FormConsentViewModelClientResponse, any>({
        path: `/api/FormConsents/AddFormConsent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormConsents
     * @name FormConsentsUpdateFormConsentCreate
     * @request POST:/api/FormConsents/UpdateFormConsent
     * @secure
     */
    formConsentsUpdateFormConsentCreate: (
      data: UpdateFormConsentRequest,
      params: RequestParams = {},
    ) =>
      this.request<FormConsentViewModelClientResponse, any>({
        path: `/api/FormConsents/UpdateFormConsent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FormConsents
     * @name FormConsentsDeleteFormConsentCreate
     * @request POST:/api/FormConsents/DeleteFormConsent
     * @secure
     */
    formConsentsDeleteFormConsentCreate: (
      data: DeleteFormConsentRequest,
      params: RequestParams = {},
    ) =>
      this.request<FormConsentViewModelClientResponse, any>({
        path: `/api/FormConsents/DeleteFormConsent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsGetConfigurationList
     * @request GET:/api/Forms/GetConfiguration
     * @secure
     */
    formsGetConfigurationList: (params: RequestParams = {}) =>
      this.request<FormsConfigurationViewModelClientResponse, any>({
        path: `/api/Forms/GetConfiguration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsCreateSoleProprietorshipCreate
     * @request POST:/api/Forms/CreateSoleProprietorship
     * @secure
     */
    formsCreateSoleProprietorshipCreate: (
      data: CreateSoleProprietorshipRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/CreateSoleProprietorship`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsCreateOperatingCompanyCreate
     * @request POST:/api/Forms/CreateOperatingCompany
     * @secure
     */
    formsCreateOperatingCompanyCreate: (
      data: CreateOperatingCompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/CreateOperatingCompany`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsCreateHoldingStructureCreate
     * @request POST:/api/Forms/CreateHoldingStructure
     * @secure
     */
    formsCreateHoldingStructureCreate: (
      data: CreateHoldingStructureRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/CreateHoldingStructure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsCreateLtdCreate
     * @request POST:/api/Forms/CreateLtd
     * @secure
     */
    formsCreateLtdCreate: (
      data: CreateOperatingCompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/CreateLtd`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsCreateLtdHoldingStructureCreate
     * @request POST:/api/Forms/CreateLtdHoldingStructure
     * @secure
     */
    formsCreateLtdHoldingStructureCreate: (
      data: CreateHoldingStructureRequest,
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/CreateLtdHoldingStructure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsUpdateSoleProprietorshipUpdate
     * @request PUT:/api/Forms/UpdateSoleProprietorship
     * @secure
     */
    formsUpdateSoleProprietorshipUpdate: (
      data: CreateSoleProprietorshipRequest,
      query?: {
        /** @format uuid */
        caseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/UpdateSoleProprietorship`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsUpdateOperatingCompanyUpdate
     * @request PUT:/api/Forms/UpdateOperatingCompany
     * @secure
     */
    formsUpdateOperatingCompanyUpdate: (
      data: CreateOperatingCompanyRequest,
      query?: {
        /** @format uuid */
        caseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/UpdateOperatingCompany`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Forms
     * @name FormsUpdateLtdUpdate
     * @request PUT:/api/Forms/UpdateLtd
     * @secure
     */
    formsUpdateLtdUpdate: (
      data: CreateOperatingCompanyRequest,
      query?: {
        /** @format uuid */
        caseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseViewObjectClientResponse, any>({
        path: `/api/Forms/UpdateLtd`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name ImageUploadImagesUpdate
     * @request PUT:/api/Image/UploadImages
     * @secure
     */
    imageUploadImagesUpdate: (
      query: {
        /** @format uuid */
        uniqueId: string;
      },
      data: {
        images?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ImagesUploadedResponseClientResponse, any>({
        path: `/api/Image/UploadImages`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name ImageReplaceImagesUpdate
     * @request PUT:/api/Image/ReplaceImages
     * @secure
     */
    imageReplaceImagesUpdate: (
      query: {
        /** @format uuid */
        uniqueId: string;
      },
      data: {
        images?: File[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ImagesUploadedResponseClientResponse, any>({
        path: `/api/Image/ReplaceImages`,
        method: "PUT",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Image
     * @name ImageDeleteImagesDelete
     * @request DELETE:/api/Image/DeleteImages
     * @secure
     */
    imageDeleteImagesDelete: (
      query: {
        /** @format uuid */
        uniqueId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Image/DeleteImages`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags IpInfo
     * @name IpInfoGetInfoList
     * @request GET:/api/IpInfo/GetInfo
     * @secure
     */
    ipInfoGetInfoList: (
      query: {
        ip: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<IpInformationViewObjectClientResponse, any>({
        path: `/api/IpInfo/GetInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycTemplatesList
     * @request GET:/api/Kyc/Templates
     * @secure
     */
    kycTemplatesList: (params: RequestParams = {}) =>
      this.request<KycTemplateViewListClientResponse, any>({
        path: `/api/Kyc/Templates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycSaveTemplateCreate
     * @request POST:/api/Kyc/SaveTemplate
     * @secure
     */
    kycSaveTemplateCreate: (
      data: SaveKycTemplateRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycTemplateViewClientResponse, any>({
        path: `/api/Kyc/SaveTemplate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycPublishCreate
     * @request POST:/api/Kyc/Publish
     * @secure
     */
    kycPublishCreate: (
      query?: {
        /** @format uuid */
        templateId?: string;
        /** @format int32 */
        revision?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycTemplateViewClientResponse, any>({
        path: `/api/Kyc/Publish`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycPreviewCreate
     * @request POST:/api/Kyc/Preview
     * @secure
     */
    kycPreviewCreate: (data: KycPreviewRequest, params: RequestParams = {}) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/Preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycOpenCreate
     * @request POST:/api/Kyc/Open
     * @secure
     */
    kycOpenCreate: (
      data:
        | KycAccessRequest
        | SaveKycAnswersRequest
        | CorrectKycAnswersRequest
        | UploadKycAttachmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/Open`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycSaveAnswersCreate
     * @request POST:/api/Kyc/SaveAnswers
     * @secure
     */
    kycSaveAnswersCreate: (
      data: SaveKycAnswersRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/SaveAnswers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycSubmitCreate
     * @request POST:/api/Kyc/Submit
     * @secure
     */
    kycSubmitCreate: (
      data: SaveKycAnswersRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/Submit`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycCorrectAnswersCreate
     * @request POST:/api/Kyc/CorrectAnswers
     * @secure
     */
    kycCorrectAnswersCreate: (
      data: CorrectKycAnswersRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/CorrectAnswers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycUploadAttachmentCreate
     * @request POST:/api/Kyc/UploadAttachment
     * @secure
     */
    kycUploadAttachmentCreate: (
      data: UploadKycAttachmentRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/UploadAttachment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycOpenAttachmentCreate
     * @request POST:/api/Kyc/OpenAttachment
     * @secure
     */
    kycOpenAttachmentCreate: (
      data:
        | KycAccessRequest
        | SaveKycAnswersRequest
        | CorrectKycAnswersRequest
        | UploadKycAttachmentRequest,
      query?: {
        /** @format uuid */
        attachmentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/OpenAttachment`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycRemoveAttachmentCreate
     * @request POST:/api/Kyc/RemoveAttachment
     * @secure
     */
    kycRemoveAttachmentCreate: (
      data:
        | KycAccessRequest
        | SaveKycAnswersRequest
        | CorrectKycAnswersRequest
        | UploadKycAttachmentRequest,
      query?: {
        /** @format uuid */
        attachmentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/RemoveAttachment`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycInvitationList
     * @request GET:/api/Kyc/Invitation
     * @secure
     */
    kycInvitationList: (
      query?: {
        /** @format uuid */
        subjectId?: string;
        participant?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycLinkViewClientResponse, any>({
        path: `/api/Kyc/Invitation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycSubmissionsList
     * @request GET:/api/Kyc/Submissions
     * @secure
     */
    kycSubmissionsList: (params: RequestParams = {}) =>
      this.request<KycSubmissionListItemListClientResponse, any>({
        path: `/api/Kyc/Submissions`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycSubmissionList
     * @request GET:/api/Kyc/Submission
     * @secure
     */
    kycSubmissionList: (
      query?: {
        /** @format uuid */
        submissionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/Submission`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycCaseSubmissionsList
     * @request GET:/api/Kyc/CaseSubmissions
     * @secure
     */
    kycCaseSubmissionsList: (
      query?: {
        /** @format uuid */
        caseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CaseKycSubmissionViewListClientResponse, any>({
        path: `/api/Kyc/CaseSubmissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycInternalReportList
     * @request GET:/api/Kyc/InternalReport
     * @secure
     */
    kycInternalReportList: (
      query?: {
        /** @format uuid */
        caseId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/InternalReport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycReviewCreate
     * @request POST:/api/Kyc/Review
     * @secure
     */
    kycReviewCreate: (data: ReviewKycRequest, params: RequestParams = {}) =>
      this.request<KycFormViewClientResponse, any>({
        path: `/api/Kyc/Review`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycScreeningList
     * @request GET:/api/Kyc/Screening
     * @secure
     */
    kycScreeningList: (
      query?: {
        /** @format uuid */
        submissionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycScreeningViewClientResponse, any>({
        path: `/api/Kyc/Screening`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycRunScreeningCreate
     * @request POST:/api/Kyc/RunScreening
     * @secure
     */
    kycRunScreeningCreate: (
      data: RunKycScreeningRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycScreeningViewClientResponse, any>({
        path: `/api/Kyc/RunScreening`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycDecideScreeningCreate
     * @request POST:/api/Kyc/DecideScreening
     * @secure
     */
    kycDecideScreeningCreate: (
      data: DecideKycScreeningRequest,
      params: RequestParams = {},
    ) =>
      this.request<KycScreeningViewClientResponse, any>({
        path: `/api/Kyc/DecideScreening`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycScreeningReportList
     * @request GET:/api/Kyc/ScreeningReport
     * @secure
     */
    kycScreeningReportList: (
      query?: {
        /** @format uuid */
        submissionId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/ScreeningReport`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycDownloadAttachmentList
     * @request GET:/api/Kyc/DownloadAttachment
     * @secure
     */
    kycDownloadAttachmentList: (
      query?: {
        /** @format uuid */
        attachmentId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/DownloadAttachment`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Kyc
     * @name KycDownloadPdfList
     * @request GET:/api/Kyc/DownloadPdf
     * @secure
     */
    kycDownloadPdfList: (
      query?: {
        /** @format uuid */
        submissionId?: string;
        signed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<KycDownloadClientResponse, any>({
        path: `/api/Kyc/DownloadPdf`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsGetActiveNotificationsList
     * @request GET:/api/Notifications/GetActiveNotifications
     * @secure
     */
    notificationsGetActiveNotificationsList: (
      query: {
        target: NotificationTarget;
      },
      params: RequestParams = {},
    ) =>
      this.request<NotificationViewModelClientResponse, any>({
        path: `/api/Notifications/GetActiveNotifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsGetNotificationsList
     * @request GET:/api/Notifications/GetNotifications
     * @secure
     */
    notificationsGetNotificationsList: (params: RequestParams = {}) =>
      this.request<NotificationViewModelClientResponse, any>({
        path: `/api/Notifications/GetNotifications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsAddOrUpdateNotificationCreate
     * @request POST:/api/Notifications/AddOrUpdateNotification
     * @secure
     */
    notificationsAddOrUpdateNotificationCreate: (
      data: AddOrUpdateNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.request<NotificationViewObjectClientResponse, any>({
        path: `/api/Notifications/AddOrUpdateNotification`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsAddOrUpdateNotificationOrdersCreate
     * @request POST:/api/Notifications/AddOrUpdateNotificationOrders
     * @secure
     */
    notificationsAddOrUpdateNotificationOrdersCreate: (
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<NotificationViewModelClientResponse, any>({
        path: `/api/Notifications/AddOrUpdateNotificationOrders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsDeleteNotificationDelete
     * @request DELETE:/api/Notifications/DeleteNotification
     * @secure
     */
    notificationsDeleteNotificationDelete: (
      query: {
        /** @format uuid */
        notificationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NotificationViewObjectClientResponse, any>({
        path: `/api/Notifications/DeleteNotification`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsMarkNotificationAsSeenCreate
     * @request POST:/api/Notifications/MarkNotificationAsSeen
     * @secure
     */
    notificationsMarkNotificationAsSeenCreate: (
      query: {
        /** @format uuid */
        notificationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Notifications/MarkNotificationAsSeen`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notifications
     * @name NotificationsRePublishNotificationCreate
     * @request POST:/api/Notifications/RePublishNotification
     * @secure
     */
    notificationsRePublishNotificationCreate: (
      query: {
        /** @format uuid */
        notificationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<BooleanClientResponse, any>({
        path: `/api/Notifications/RePublishNotification`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersGetPartnersList
     * @request GET:/api/Partners/GetPartners
     * @secure
     */
    partnersGetPartnersList: (params: RequestParams = {}) =>
      this.request<PartnersViewModelClientResponse, any>({
        path: `/api/Partners/GetPartners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersGetDataLonIntegrationList
     * @request GET:/api/Partners/GetDataLonIntegration
     * @secure
     */
    partnersGetDataLonIntegrationList: (params: RequestParams = {}) =>
      this.request<DataLonIntegrationViewModelClientResponse, any>({
        path: `/api/Partners/GetDataLonIntegration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersUpdateDataLonIntegrationCreate
     * @request POST:/api/Partners/UpdateDataLonIntegration
     * @secure
     */
    partnersUpdateDataLonIntegrationCreate: (
      data: UpdateDataLonIntegrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<DataLonIntegrationViewModelClientResponse, any>({
        path: `/api/Partners/UpdateDataLonIntegration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersAddPartnerCreate
     * @request POST:/api/Partners/AddPartner
     * @secure
     */
    partnersAddPartnerCreate: (
      data: AddPartnerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerViewModelClientResponse, any>({
        path: `/api/Partners/AddPartner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersUpdatePartnerCreate
     * @request POST:/api/Partners/UpdatePartner
     * @secure
     */
    partnersUpdatePartnerCreate: (
      data: UpdatePartnerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerViewModelClientResponse, any>({
        path: `/api/Partners/UpdatePartner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Partners
     * @name PartnersDeletePartnerCreate
     * @request POST:/api/Partners/DeletePartner
     * @secure
     */
    partnersDeletePartnerCreate: (
      data: DeletePartnerRequest,
      params: RequestParams = {},
    ) =>
      this.request<PartnerViewModelClientResponse, any>({
        path: `/api/Partners/DeletePartner`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentFees
     * @name PaymentFeesGetPaymentFeesList
     * @request GET:/api/PaymentFees/GetPaymentFees
     * @secure
     */
    paymentFeesGetPaymentFeesList: (params: RequestParams = {}) =>
      this.request<PaymentFeesViewModelClientResponse, any>({
        path: `/api/PaymentFees/GetPaymentFees`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentFees
     * @name PaymentFeesAddPaymentFeeCreate
     * @request POST:/api/PaymentFees/AddPaymentFee
     * @secure
     */
    paymentFeesAddPaymentFeeCreate: (
      data: AddPaymentFeeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentFeeViewModelClientResponse, any>({
        path: `/api/PaymentFees/AddPaymentFee`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentFees
     * @name PaymentFeesUpdatePaymentFeeCreate
     * @request POST:/api/PaymentFees/UpdatePaymentFee
     * @secure
     */
    paymentFeesUpdatePaymentFeeCreate: (
      data: UpdatePaymentFeeRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentFeeViewModelClientResponse, any>({
        path: `/api/PaymentFees/UpdatePaymentFee`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentProducts
     * @name PaymentProductsGetPaymentProductsList
     * @request GET:/api/PaymentProducts/GetPaymentProducts
     * @secure
     */
    paymentProductsGetPaymentProductsList: (params: RequestParams = {}) =>
      this.request<PaymentProductsViewModelClientResponse, any>({
        path: `/api/PaymentProducts/GetPaymentProducts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags PaymentProducts
     * @name PaymentProductsUpdatePaymentProductCreate
     * @request POST:/api/PaymentProducts/UpdatePaymentProduct
     * @secure
     */
    paymentProductsUpdatePaymentProductCreate: (
      data: UpdatePaymentProductRequest,
      params: RequestParams = {},
    ) =>
      this.request<PaymentProductViewModelClientResponse, any>({
        path: `/api/PaymentProducts/UpdatePaymentProduct`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchPostalCodeList
     * @request GET:/api/Search/SearchPostalCode
     * @secure
     */
    searchSearchPostalCodeList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PostalCodeSearchResponseClientResponse, any>({
        path: `/api/Search/SearchPostalCode`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchAddressesList
     * @request GET:/api/Search/SearchAddresses
     * @secure
     */
    searchSearchAddressesList: (
      query?: {
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SearchAddressesResponseClientResponse, any>({
        path: `/api/Search/SearchAddresses`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchGetPropertyInformationList
     * @request GET:/api/Search/GetPropertyInformation
     * @secure
     */
    searchGetPropertyInformationList: (
      query?: {
        addressId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PropertyInformationResponseClientResponse, any>({
        path: `/api/Search/GetPropertyInformation`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Search
     * @name SearchSearchCompaniesList
     * @request GET:/api/Search/SearchCompanies
     * @secure
     */
    searchSearchCompaniesList: (
      query?: {
        term?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CvrCompanyArrayClientResponse, any>({
        path: `/api/Search/SearchCompanies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Statistics
     * @name StatisticsGetOverviewCreate
     * @request POST:/api/Statistics/GetOverview
     * @secure
     */
    statisticsGetOverviewCreate: (
      data: StatisticsRequest,
      params: RequestParams = {},
    ) =>
      this.request<StatisticsViewModelClientResponse, any>({
        path: `/api/Statistics/GetOverview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Terms
     * @name TermsGetList
     * @request GET:/api/Terms/Get
     * @secure
     */
    termsGetList: (params: RequestParams = {}) =>
      this.request<StringClientResponse, any>({
        path: `/api/Terms/Get`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUsersCreate
     * @request POST:/api/Users/GetUsers
     * @secure
     */
    usersGetUsersCreate: (params: RequestParams = {}) =>
      this.request<UsersViewModelClientResponse, any>({
        path: `/api/Users/GetUsers`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetEmployeesCreate
     * @request POST:/api/Users/GetEmployees
     * @secure
     */
    usersGetEmployeesCreate: (params: RequestParams = {}) =>
      this.request<UsersViewModelClientResponse, any>({
        path: `/api/Users/GetEmployees`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersSearchCreate
     * @request POST:/api/Users/Search
     * @secure
     */
    usersSearchCreate: (data: UserSearchFilter, params: RequestParams = {}) =>
      this.request<UsersSearchViewModelClientResponse, any>({
        path: `/api/Users/Search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUserByIdList
     * @request GET:/api/Users/GetUserById
     * @secure
     */
    usersGetUserByIdList: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/GetUserById`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUsersByIdCreate
     * @request POST:/api/Users/GetUsersById
     * @secure
     */
    usersGetUsersByIdCreate: (
      data: UsersByIdRequest,
      params: RequestParams = {},
    ) =>
      this.request<UsersViewModelClientResponse, any>({
        path: `/api/Users/GetUsersById`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateProfileImageUpdate
     * @request PUT:/api/Users/UpdateProfileImage
     * @secure
     */
    usersUpdateProfileImageUpdate: (
      data: {
        /** @format binary */
        formFile?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/UpdateProfileImage`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateLogoUpdate
     * @request PUT:/api/Users/UpdateLogo
     * @secure
     */
    usersUpdateLogoUpdate: (
      data: {
        /** @format binary */
        formFile?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/UpdateLogo`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersRemoveLogoCreate
     * @request POST:/api/Users/RemoveLogo
     * @secure
     */
    usersRemoveLogoCreate: (params: RequestParams = {}) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/RemoveLogo`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetUserLoginHistoryCreate
     * @request POST:/api/Users/GetUserLoginHistory
     * @secure
     */
    usersGetUserLoginHistoryCreate: (params: RequestParams = {}) =>
      this.request<UserLoginHistoryViewModelClientResponse, any>({
        path: `/api/Users/GetUserLoginHistory`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersGetLoginHistoryForUserCreate
     * @request POST:/api/Users/GetLoginHistoryForUser
     * @secure
     */
    usersGetLoginHistoryForUserCreate: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserLoginHistoryViewModelClientResponse, any>({
        path: `/api/Users/GetLoginHistoryForUser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersCreateUserCreate
     * @request POST:/api/Users/CreateUser
     * @secure
     */
    usersCreateUserCreate: (
      data: CreateUserRequest | AddOrUpdateUserRequest | UpdateUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/CreateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateUserCreate
     * @request POST:/api/Users/UpdateUser
     * @secure
     */
    usersUpdateUserCreate: (
      data: UpdateUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/UpdateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersAddOrUpdateUserCreate
     * @request POST:/api/Users/AddOrUpdateUser
     * @secure
     */
    usersAddOrUpdateUserCreate: (
      data: AddOrUpdateUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/AddOrUpdateUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersDeleteUserCreate
     * @request POST:/api/Users/DeleteUser
     * @secure
     */
    usersDeleteUserCreate: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/DeleteUser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersRestoreUserCreate
     * @request POST:/api/Users/RestoreUser
     * @secure
     */
    usersRestoreUserCreate: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/RestoreUser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersBlockUserCreate
     * @request POST:/api/Users/BlockUser
     * @secure
     */
    usersBlockUserCreate: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/BlockUser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUnblockUserCreate
     * @request POST:/api/Users/UnblockUser
     * @secure
     */
    usersUnblockUserCreate: (
      query: {
        /** @format uuid */
        userId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/UnblockUser`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersUpdateAllowableIpsForUserCreate
     * @request POST:/api/Users/UpdateAllowableIpsForUser
     * @secure
     */
    usersUpdateAllowableIpsForUserCreate: (
      data: AddOrUpdateAllowableIpsRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/UpdateAllowableIpsForUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name UsersResetPasswordForUserCreate
     * @request POST:/api/Users/ResetPasswordForUser
     * @secure
     */
    usersResetPasswordForUserCreate: (
      data: ResetPasswordForUserRequest,
      params: RequestParams = {},
    ) =>
      this.request<UserViewModelClientResponse, any>({
        path: `/api/Users/ResetPasswordForUser`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
